export const en = {
  "common.loading": "Loading your studio…",
  "common.retry": "Try again",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.save": "Save",
  "common.saving": "Saving…",
  "common.create": "Create",
  "common.creating": "Creating…",
  "common.open": "Open",
  "common.delete": "Delete",
  "common.back": "Back",
  "common.language": "Language",
  "common.english": "English",
  "common.spanish": "Spanish",
  "nav.dashboard": "Home",
  "nav.templates": "Templates",
  "nav.billing": "Plans",
  "nav.skip": "Skip to main content",
  "nav.primary": "Primary navigation",
  "nav.builder": "Builder",
  "nav.history": "History",
  "menu.workspace": "Workspace views",
  "menu.build": "Build & inspect",
  "menu.account": "Account",
  "menu.testPlan": "{plan} · test plan",
  "auth.eyebrow.mfa": "A safe place to build something amazing",
  "auth.eyebrow.lya": "The professional agent studio",
  "auth.hero.mfa": "Big ideas start with one bright block.",
  "auth.hero.lya": "Put AI agents to work for your team.",
  "auth.or": "or",
  "auth.welcomeTitle": "Welcome back!",
  "auth.welcomeSub": "Sign in to keep building",
  "auth.createTitle": "Create your account",
  "auth.createSub": "Start building agents in seconds",
  "auth.tab.signIn": "Sign in",
  "auth.tab.create": "Create account",
  "auth.kidsNote.mfa": "Your workspace data stays private — we never sell it.",
  "auth.title": "Sign in to {brand}",
  "auth.body.mfa": "Sign in to build, run, and direct real AI agents in your own workspace.",
  "auth.body.lya": "Managers sign in to design agents and direct real agent runs.",
  "auth.google": "Continue with Google",
  "auth.emailLabel.mfa": "Email",
  "auth.emailPlaceholder": "you@example.com",
  "auth.required": "Sign-in is required. Agent runs never fall back to a demo or simulation.",
  "auth.configMissing":
    "Sign-in is not configured for this environment. Ask the site administrator to add the V2 Firebase public configuration.",
  "auth.error": "We could not sign you in. Please try again.",
  "auth.signOut": "Sign out",
  "auth.busy": "One moment…",
  "auth.nameLabel": "Your name",
  "auth.namePlaceholder": "Your name",
  "auth.passwordLabel": "Password",
  "auth.passwordPlaceholder": "••••••••",
  "auth.password.show": "Show",
  "auth.password.hide": "Hide",
  "auth.password.toggleTitle": "Show or hide your password",
  "auth.forgot": "Forgot password?",
  "auth.cta.signIn": "Sign in",
  "auth.cta.create": "Create account",
  "auth.verifyNotice":
    "📬 Check your inbox to verify your email — we send a confirmation link when you create an account.",
  "auth.reset.title": "Reset your password",
  "auth.reset.sub": "Tell us your email and we'll send a reset link",
  "auth.reset.cta": "Email me a reset link",
  "auth.reset.sent": "If {email} has an account, a password reset link is on its way.",
  "auth.reset.back": "Back to sign in",
  "auth.err.email_in_use": "That email already has an account — flip to Sign in.",
  "auth.err.bad_email": "That doesn’t look like an email address.",
  "auth.err.weak_password": "Pick a longer password (at least 6 characters).",
  "auth.err.bad_credentials": "Email or password doesn’t match — try again.",
  "auth.err.email_provider_disabled": "Email sign-in isn’t switched on yet — use Google for now.",
  "auth.err.google_provider_disabled": "Google sign-in isn’t switched on yet — use email for now.",
  "auth.err.too_many_attempts": "Too many tries — wait a minute and try again.",
  "auth.err.popup_blocked": "Your browser blocked the Google window — allow popups and try again.",
  "auth.err.popup_closed": "The Google window closed before finishing — try again.",
  "auth.err.unauthorized_domain":
    "Sign-in isn’t allowed from this web address yet — ask whoever runs this site to authorize it.",
  "auth.err.bad_continue_url":
    "We couldn’t send the email — this web address isn’t authorized yet. Ask whoever runs this site to fix it.",
  "auth.err.firebase_not_configured": "Sign-in isn’t configured on this install.",
  "auth.err.expired_link": "That link has expired — request a fresh one and try again.",
  "auth.err.invalid_link": "That link isn’t valid any more — it may already have been used.",
  "auth.err.account_disabled":
    "This account has been disabled. Contact support if that seems wrong.",
  "auth.err.network":
    "We couldn’t reach the sign-in service — check your connection and try again.",
  "auth.err.no_firebase_session":
    "Your sign-in session isn’t available in this browser — sign out, sign back in, and try again.",
  "auth.err.enter_name": "Enter your name first.",
  "auth.err.password_mismatch": "Those passwords don’t match — type the same one twice.",
  "auth.err.unknown": "Sign-in didn’t work — please try again.",
  "release.banner.body": "A new version of the site is available.",
  "release.banner.reload": "Reload",
  "release.banner.dismiss": "Dismiss",
  "auth.banner.title": "Verify your email.",
  "auth.banner.body": "We sent a confirmation link to {email}. You can keep building meanwhile.",
  "auth.banner.resend": "Resend verification email",
  "auth.banner.resent": "Sent! Check your inbox.",
  "auth.banner.check": "I’ve verified — check again",
  "auth.banner.stillUnverified": "Still not verified — click the link in the email first.",
  "auth.banner.noSession":
    "We can’t resend from this browser. Sign out and sign back in, then try again from here.",
  "auth.action.working": "Checking your link…",
  "auth.action.verifiedTitle": "Email verified!",
  "auth.action.verifiedBody": "Thanks — your email address is confirmed.",
  "auth.action.continue": "Continue",
  "auth.action.goSignIn": "Go to sign in",
  "auth.action.resetTitle": "Choose a new password",
  "auth.action.resetFor": "for {email}",
  "auth.action.newPasswordLabel": "New password",
  "auth.action.confirmPasswordLabel": "Type it again",
  "auth.action.resetCta": "Save new password",
  "auth.action.resetDoneTitle": "Password updated!",
  "auth.action.resetDoneBody":
    "You’re signed in with your new password. Every other session has been signed out.",
  "auth.action.resetDoneSignIn": "Sign in with your new password to keep building.",
  "auth.action.recoverTitle": "Email restored",
  "auth.action.recoverBody":
    "Your sign-in email is {email} again. If you didn’t ask for this change, reset your password now.",
  "auth.action.recoverBodyNoEmail":
    "Your sign-in email was restored. If you didn’t ask for this change, reset your password now.",
  "auth.action.recoverReset": "Reset password now",
  "auth.action.expiredTitle": "This link has expired",
  "auth.action.expiredBody":
    "Links only work for a little while. Request a fresh one and try again.",
  "auth.action.invalidTitle": "This link isn’t valid",
  "auth.action.invalidBody":
    "It may have expired or already been used. Request a fresh link and try again.",
  "account.setPassword": "Set or reset password",
  "account.passwordEmailSent": "Reset email sent to {email}",
  "error.identity_email_conflict":
    "Another account already uses this verified email. Sign in the way this address originally signed up.",
  "site.invalidTitle": "This site is not configured",
  "site.invalidBody": "The current host does not map to My First Agent or Launch Your Agent.",
  "site.mismatchTitle": "Site context mismatch",
  "site.mismatchBody": "For your safety, this account cannot load under the current site address.",
  "error.backendTitle": "The studio could not connect",
  "error.backendBody":
    "The V2 backend is required. Nothing has been simulated or filled in for you.",
  "error.generic": "Something went wrong. Reference: {traceId}",
  "error.api_key_not_found": "That key no longer exists. It may already have been revoked.",
  "error.api_key_name_reserved": "That name is reserved. Choose another one.",
  "error.project_not_found": "That project wasn't found on this account.",
  "error.file_exists":
    "{displayName} is already in Files, so nothing was saved. Use another name, or save again and choose to replace it.",
  "error.authentication_required": "Your session ended. Sign in again to continue.",
  "error.run_not_ready": "This run is still starting up. Try that again in a moment.",
  "error.run_not_resumable":
    "This conversation has closed: it ended a while ago or a newer run replaced it. Start a new run to continue.",
  "error.rate_limited": "Too many requests in a minute. Wait a moment and try again.",
  "error.run_budget_too_high": "That budget is above the per-run maximum. Choose a smaller cap.",
  "error.overlay_invalid":
    "This project's Foundry overlay isn't valid YAML, so the run can't start.",
  "error.run_budget_required": "A run always has a budget. Choose a cap instead of removing it.",
  "error.run_command_not_allowed":
    "The agent paused for your input just as this was sent. Answer the pending request, then try again.",
  "error.command_in_progress":
    "The agent is still receiving an earlier update. Give it a few seconds, then try again.",
  "error.revision_conflict": "This project changed in another window. Reload before saving again.",
  "error.credit_cap_reached": "This account needs more credits before it can run an agent.",
  "error.daily_run_cap_reached": "That's all the runs for today — try again tomorrow.",
  "error.model_not_allowed": "The model {model} isn't available on this plan.",
  "error.tool_not_allowed": "The {tool} tool isn't allowed for this profile.",
  "error.session_tool_update_failed":
    "This session couldn't apply the tool changes, so your follow-up wasn't sent. Try again; new jobs already use the saved changes.",
  "error.mcp_not_allowed": "Custom connectors aren't allowed for this profile.",
  "error.subscription_required": "This feature needs an active subscription.",
  "error.seePlans": "See plans →",
  "error.goal_required": "Give your agent a goal first — that's the mission it runs with.",
  "error.preferred_profile_unavailable":
    "This project is set to run on {profileKey}, which isn't available right now{code, select, profile_model_mismatch { — the agent's model changed since you chose it} required_capability_missing { — a tool it needs isn't available on that runtime} model_not_served { — that model doesn't run on that runtime} model_not_allowed { — that model needs a bigger plan} provider_not_allowed { — that runtime needs a bigger plan} reservations_paused { — that runtime is taking a short break} provider_not_installed { — that runtime isn't set up here} approval_mode_unsupported { — the way it asks before using a tool isn't supported on that runtime} tool_not_allowed { — a tool it uses is turned off for this profile} mcp_not_allowed { — its MCP tools need a bigger plan} mcp_server_not_in_library { — it uses an MCP server that isn't in the vetted library} skills_unsupported { — its skills aren't available on that runtime yet} other {}}. Pick another model in the Goal panel.",
  "error.profile_unavailable":
    "That profile isn't available right now{code, select, required_capability_missing { — a tool this agent needs isn't available on that runtime} model_not_served { — that model doesn't run on that runtime} model_not_allowed { — that model needs a bigger plan} provider_not_allowed { — that runtime needs a bigger plan} reservations_paused { — that runtime is taking a short break} provider_not_installed { — that runtime isn't set up here} approval_mode_unsupported { — the way it asks before using a tool isn't supported on that runtime} tool_not_allowed { — a tool it uses is turned off for this profile} mcp_not_allowed { — its MCP tools need a bigger plan} mcp_server_not_in_library { — it uses an MCP server that isn't in the vetted library} skills_unsupported { — its skills aren't available on that runtime yet} profile_model_mismatch { — the agent's model changed since you chose it} other {}}.",
  "error.profile_model_mismatch":
    "That profile runs {model}, not this agent's current model — change the model first or pick a profile for it.",
  "error.profile_key_invalid": "That isn't a valid profile.",
  "error.runtime_provider_not_allowed": "No runtime on this plan can run agents right now.",
  "error.no_runtime_provider_available":
    "No runtime is available to run agents right now. Try again in a little while.",
  "error.model_unsupported_by_runtime":
    "This agent's model doesn't run on the runtime it's set to. Pick another model in the Goal panel.",
  "error.tool_unsupported_by_runtime":
    "A tool this agent uses isn't available on the runtime it's set to. Pick another model in the Goal panel, or turn that tool off in Tools.",
  "error.tool_hitl_unsupported_by_runtime":
    "Asking before a web tool runs isn't supported on that runtime. Set the tool to Auto, or pick another model in the Goal panel.",
  "error.mcp_unsupported_by_runtime":
    "This agent's MCP tools aren't available on the runtime it's set to. Pick another model in the Goal panel.",
  "error.mcp_server_not_in_library":
    "This agent uses an MCP server that isn't in the vetted library. Remove it in Tools to run.",
  "error.mcp_server_invalid":
    "{problem, select, no_toolset {The MCP server {server} has no mcp_toolset, so this can't be saved. Add one for it — to switch the server off, keep its toolset with default_config.enabled: false.} unknown_server {An mcp_toolset names a server that isn't in mcp_servers. Add the server, or remove the toolset.} duplicate {The MCP server {server} is listed more than once, or has more than one mcp_toolset. Keep one of each.} url {The MCP server {server} needs a valid https address on a named host — no localhost, IP address or custom port.} credentials {The MCP server {server} has a username or password in its address. Take it out — a key may ride in the address's query instead.} shape {The MCP servers aren't in the right shape: each one needs type: url, a name (up to 64 letters, digits, - or _) and a url, and an agent can have at most 20.} other {This agent's MCP servers aren't set up correctly. Check mcp_servers and their mcp_toolset entries.}}",
  "error.mcp_server_unreachable":
    "{server} isn't answering right now, so nothing ran. Try again in a little while, or remove it in Tools.",
  "error.run_refused":
    "This agent can't run the way it's set up. Check its tools and its model, then try again.",
  "error.provider_rejected":
    "The model provider turned this run down before it began, so nothing ran. Try again later; if it keeps happening, the site's provider setup needs a look.",
  "error.skills_unsupported_by_runtime":
    "This agent's skills aren't available on the runtime it's set to yet. Pick another model in the Goal panel.",
  "error.runtime_provider_not_installed":
    "That runtime isn't set up here. Pick another model in the Goal panel.",
  "error.provider_not_allowed": "That runtime needs a bigger plan.",
  "profile.myProfile": "My Profile",
  "profile.openTemplates": "Browse templates →",
  "profile.subscription": "Subscription",
  "profile.currentPlan": "You're on the {plan} plan.",
  "profile.managePlan": "Manage plan",
  "apiKeys.title": "API keys",
  "apiKeys.intro":
    "A key lets a script, a command-line tool or another service call the API for your account on this site. A read key can look at templates, projects and runs; a write key can also save projects and start runs.",
  "apiKeys.lastUsedNote": "Last use is recorded at most every five minutes.",
  "apiKeys.empty": "No API keys yet. Create one below.",
  "apiKeys.caption": "Your API keys",
  "apiKeys.col.name": "Name",
  "apiKeys.col.prefix": "Starts with",
  "apiKeys.col.access": "Access",
  "apiKeys.col.project": "Project",
  "apiKeys.col.created": "Created",
  "apiKeys.col.lastUsed": "Last used",
  "apiKeys.col.expires": "Expires",
  "apiKeys.col.actions": "Actions",
  "apiKeys.access.read": "Read",
  "apiKeys.access.write": "Write",
  "apiKeys.allProjects": "All projects",
  "apiKeys.unknownProject": "Project {id}",
  "apiKeys.never": "Never",
  "apiKeys.expired": "Expired {date}",
  "apiKeys.revoke": "Revoke",
  "apiKeys.revokeLabel": "Revoke {name}",
  "apiKeys.revoking": "Revoking…",
  "apiKeys.revokeConfirm":
    "Revoke “{name}”? Anything that uses it stops working at its next request. This can't be undone.",
  "apiKeys.create.title": "Create a key",
  "apiKeys.field.name": "Name",
  "apiKeys.field.namePlaceholder": "e.g. My CLI",
  "apiKeys.field.access": "Access",
  "apiKeys.field.accessRead": "Read: look at templates, projects and runs",
  "apiKeys.field.accessWrite": "Write: also save projects and start runs",
  "apiKeys.field.project": "Project",
  "apiKeys.field.expiry": "Expires after (days)",
  "apiKeys.field.expiryHint": "1 to 365. Leave it empty for a key that never expires.",
  "apiKeys.create.submit": "Create key",
  "apiKeys.create.lockedHint":
    "Save the new key's secret and choose Done before creating another key.",
  "apiKeys.projects.loading": "Loading your projects…",
  "apiKeys.projects.failed":
    "Your projects could not be loaded, so only a key for all projects can be made right now.",
  "apiKeys.projects.retry": "Retry",
  "apiKeys.projects.none": "You have no projects yet, so the key will cover all projects.",
  "apiKeys.secret.title": "Your new key",
  "apiKeys.secret.warning": "Copy it now and keep it somewhere safe. It will not be shown again.",
  "apiKeys.secret.label": "Secret for {name}",
  "apiKeys.secret.copy": "Copy",
  "apiKeys.secret.copied": "Copied",
  "apiKeys.secret.copyFailed": "Couldn't copy. Select the key and copy it yourself.",
  "apiKeys.secret.done": "I've saved it",
  "comingNext.title": "The builder arrives in the next section",
  "comingNext.body":
    "Projects and runs are not part of this release yet. Your account, the templates and your plan are ready; building and running agents comes next.",
  "comingNext.keptIdea": "Your idea is kept:",
  "comingNext.templates": "Browse the templates meanwhile",
  "comingNext.history.title": "Run history arrives with projects",
  "comingNext.history.body":
    "Runs are not part of this release yet, so there is no history to show. Once projects and runs ship in the next section, every run you start is listed here.",
  "comingNext.marketplace.title": "The marketplace arrives in a later section",
  "comingNext.marketplace.body":
    "Community templates and shared template links are not part of this release yet. The official templates are ready to browse now.",
  "comingNext.admin.title": "The costing sheet arrives in Section 2",
  "comingNext.admin.body":
    "It arrives once runs record their cost. The admin dashboard is live at /admin.",
  "builder.blocks": "Blocks",
  "builder.yaml": "Agent YAML",
  "builder.workspace": "Workspace",
  "builder.console": "Run console",
  "builder.runAlreadyStarted": "This run already started.",
  "builder.openStartedRun": "Open the run",
  "builder.projectSavedHint": "Open the Template Library — your work stays saved in this project.",
  "builder.resizePanes": "Resize panels",
  "builder.run": "Run agent",
  "builder.running": "Running…",
  "builder.code": "Code",
  "builder.ready": "ready",
  "builder.jobRunning": "JOB RUNNING",
  "builder.stopping": "STOPPING…",
  "builder.preparingOutputs": "PREPARING OUTPUTS",
  "builder.needsYou": "NEEDS YOU",
  "builder.answerNeeded": "ANSWER",
  // Browser-tab titles so a backgrounded tab pulls the learner back — and says
  // WHICH kind of pause is waiting (a real question vs a tool-permission ask).
  "builder.tabNeedsYou": "🔔 Needs you — {project}",
  "builder.tabAnswer": "⭐ Answer the agent — {project}",
  "builder.newJob": "New job",
  "canvas.whenRun": "when Run is clicked",
  "canvas.setGoal": "set goal to",
  "canvas.config": "config",
  "canvas.help": "help me",
  "canvas.helpTitle": "turn a rough idea into a crisp mission + rubric",
  "canvas.files": "Files:",
  "canvas.pill.uploads": "Uploads · {count}",
  "canvas.pill.memory": "Memory · {count}",
  "canvas.repeatUntil": "repeat until",
  "canvas.answerReady": "answer is ready",
  "canvas.or": "or",
  "canvas.outOfTries": "out of tries (max {tries})",
  "canvas.think": "think about the next step",
  "canvas.toolbelt": "TOOLBELT — TAP TO ADD OR REMOVE · THE AGENT PICKS EACH LOOP",
  "canvas.addTool": "+ add tool",
  "canvas.team.title": "TEAM — THE AGENT HANDS WORK TO THESE MEMBERS",
  "canvas.team.add": "+ add a team",
  "canvas.team.addMember": "+ add member",
  "canvas.team.remove": "Remove {member} from the team",
  "canvas.team.removeTeam": "remove team",
  "canvas.team.advisor": "advisor",
  "canvas.team.advisorModel": "Advisor model",
  "canvas.team.subagents": "subagents",
  "canvas.team.workflows": "workflows",
  "canvas.team.inline": "may define its own",
  "canvas.team.listHasMembers": "Remove its members before switching this list off",
  "canvas.team.coordinatorNote": "This team is a coordinator: edit its roster in the Code view.",
  "canvas.team.readOnlyNote":
    "This team is written in a shape the blocks don't edit: use the Code view.",
  "canvas.team.pickerTitle": "Add a team member",
  "canvas.team.pickerBlurb":
    "Single agents published on this site. A member joins at its latest live version.",
  "canvas.team.pickerSearch": "Search by name",
  "canvas.team.pickerEmpty": "No single agents match.",
  "canvas.team.pickerMember": "already a member",
  "canvas.lookBack": "look at what came back",
  "canvas.goAround": "go around again",
  "canvas.show": "show",
  "canvas.finalAnswer": "the final answer",
  "canvas.footerHint":
    "The agent runs this loop over and over until the goal is done. Tap Code to see the real code →",
  "canvas.gradersBadge": "{graders} graders · {tries} tries",
  "cfg.done": "done",
  "cfg.goalHeader": "AGENT CONFIG — SYNCED WITH YAML",
  "cfg.goalLabel": "GOAL — WHAT THE AGENT SHOULD DO",
  "cfg.name": "NAME",
  "cfg.description": "DESCRIPTION",
  "cfg.model": "MODEL",
  "canvas.applySuggestion": "Apply helper suggestion",
  "cfg.systemPrompt": "SYSTEM PROMPT",
  "cfg.toolbeltHeader": "TOOLBELT CONFIG",
  "cfg.ask": "Ask first",
  "cfg.auto": "Auto",
  "cfg.effect.allow": "allowed",
  "cfg.effect.ask": "asks you",
  "cfg.effect.provider_decides": "the agent decides",
  "cfg.support.none": "Not available for this model here",
  "cfg.model.held": "This model's runtime is on hold.",
  "cfg.model.without": "Runs without {tools}",
  "cfg.mcpServers": "MCP SERVERS",
  "cfg.addServer": "+ server",
  "cfg.gradersHeader": "GRADERS — HOW WE SCORE DONE",
  "cfg.tries": "TRIES",
  "cfg.graderCatalog": "GRADER LIBRARY — CHECK THE ONES THAT MATTER",
  "cfg.rubricHint":
    "Sent as define_outcome — a separate grader scores each rubric line and the agent retries until satisfied or out of tries.",
  "cfg.rubricLabel": "Done looks like — your own lines, one gradeable line each",
  "cfg.rubricPlaceholder":
    "fact-file.md exists with 5 real deep-sea creatures, each with one weird fact",
  "cfg.composedRubric": "Composed rubric — sent with define_outcome",
  "cfg.composedRubricFromFile":
    "The rubric comes from the selected file — the lines above are not sent.",
  "cfg.rubricWarnWrite":
    "⚠ This rubric expects a file or deliverable, but the write tool is off. Turn on write, or pick a better-suited agent.",
  "cfg.rubricWarnSearch":
    "⚠ This rubric expects web research, but the search tool is off. Turn on search the web, or pick a better-suited agent.",
  "cfg.rubricSource": "RUBRIC SOURCE",
  "cfg.rubricSourceInline": "inline text (rubric above)",
  "cfg.graderEmits": "emits →",
  "cfg.graderInfo": "details",
  "grader.detail.produced-result":
    "The most basic check: did the agent actually make the thing? Fails when the run ends with no file, an empty file, or one that errors on open.",
  "grader.detail.regex-present":
    "Case-insensitive pattern match over the final output — the cheapest way to pin a required section, heading, or phrase.",
  "grader.detail.must-mention":
    "The answer must cite the listed terms (comma-separate several). Numerically right but never citing its anchor still fails.",
  "grader.detail.numeric-tolerance":
    "Ground-truth check: recompute the expected value from the source data, then require the answer's closest number to land within the tolerance band.",
  "grader.detail.ranked-mention":
    "For 'rank these' missions: the known-critical item must appear in the first N rows of the output's ranked list or table.",
  "grader.detail.turn-budget":
    "Efficiency grader: right answer AND within budget. Correct but over budget counts as pass-slow, so slowness is visible without failing correctness.",
  "grader.detail.wall-budget": "A wall-clock ceiling on the whole run, measured in seconds.",
  "grader.detail.text-judge.mfa":
    "An LLM judge scores the writing: clarity, correctness, and fit for the reader.",
  "grader.detail.coherence-judge":
    "An LLM judge: every heading is a promise, and the body has to keep it.",
  "cfg.mcpModalTitle": "Add a tool server",
  "cfg.mcpModalBlurb": "Pick a server your agent can use. These are free and need no login.",
  "cfg.mcpLoading": "Loading servers…",
  "cfg.mcpEmpty": "No servers available right now.",
  "cfg.tryIt": "Try it",
  "cfg.add": "Add",
  "cfg.added": "Added",
  "cfg.testing": "testing…",
  "cfg.testOk": "reachable ✓",
  "cfg.testFail": "couldn't reach it",
  "mcpLib.deepwiki.name": "DeepWiki (open-source docs)",
  "mcpLib.deepwiki.blurb":
    "Ask questions about any public GitHub project. A real server — no login needed.",
  "mcpLib.mslearn.name": "Microsoft Learn (Microsoft docs)",
  "mcpLib.mslearn.blurb": "Search official Microsoft and Azure documentation. No login needed.",
  "mcpLib.huggingface.name": "Hugging Face (AI models)",
  "mcpLib.huggingface.blurb":
    "Search AI models, datasets, and research papers on Hugging Face. No login needed.",
  "mcpLib.cloudflare-docs.name": "Cloudflare Docs",
  "mcpLib.cloudflare-docs.blurb": "Search Cloudflare's product documentation. No login needed.",
  "mcpLib.aws-knowledge.name": "AWS Knowledge (AWS docs)",
  "mcpLib.aws-knowledge.blurb": "Search official AWS documentation and guides. No login needed.",
  "mcpLib.context7.name": "Context7 (library docs)",
  "mcpLib.context7.blurb":
    "Look up current docs for popular code libraries. No login needed (usage limits apply).",
  "mcpLib.gitmcp.name": "GitMCP (any GitHub repo)",
  "mcpLib.gitmcp.blurb":
    "Read the docs and search the code of any public GitHub project. No login needed.",
  "mcpLib.claude-docs.name": "Claude Docs (Anthropic)",
  "mcpLib.claude-docs.blurb":
    "Search Anthropic's Claude documentation — models, API, and guides. No login needed.",
  "mcpLib.claude-code-docs.name": "Claude Code Docs",
  "mcpLib.claude-code-docs.blurb": "Search the Claude Code documentation. No login needed.",
  "mcpLib.ip-attribution.name": "IP Attribution",
  "mcpLib.ip-attribution.blurb":
    "Look up and attribute IP addresses — ASN, RDAP, recon, and reports. No login needed.",
  "mcpLib.comingSoon.mfa": "Coming soon.",
  "builder.stop": "Stop",
  "builder.runs.stopTitle": "Stop ends the agent's turn, not its workflow runs.",
  "builder.saved": "Saved",
  "builder.unsaved": "Unsaved changes",
  "builder.viewOnlyLive": "This run is live. The setup is view-only until it ends.",
  "builder.preflight.label": "Before you run",
  "builder.preflight.checking": "Checking the run…",
  "builder.preflight.failed": "Couldn't check the run.",
  "builder.preflight.retry": "Check again",
  "builder.preflight.ready": "Ready to run",
  "builder.preflight.warnings": "Ready, with {count, plural, one {# warning} other {# warnings}}",
  "builder.preflight.blocked":
    "{count, plural, one {# thing blocks} other {# things block}} this run",
  "builder.preflight.details": "Details",
  "builder.preflight.hideDetails": "Hide details",
  "builder.preflight.cap": "Cap {amount} (max {max})",
  "builder.preflight.capLine": "Spending cap: {amount} by default; a run can take up to {max}.",
  "builder.preflight.blockersTitle": "What blocks this run",
  "builder.preflight.checksTitle": "Checks",
  "builder.preflight.needsTitle": "What the run needs",
  "builder.preflight.severity.fail": "Fail",
  "builder.preflight.severity.warn": "Warning",
  "builder.preflight.severity.info": "Note",
  "builder.preflight.needs.none": "Nothing beyond the model.",
  "builder.preflight.needs.web": "Web search or fetch",
  "builder.preflight.needs.runsCode": "Runs code in a sandbox",
  "builder.preflight.needs.connectors": "Connectors: {names}",
  "builder.preflight.needs.skills": "Skills: {names}",
  "builder.preflight.needs.mcpHosts": "MCP hosts: {hosts}",
  "builder.preflight.blocker.agent_yaml_invalid": "The agent's setup can't be read.",
  "builder.preflight.blocker.mcp_server_invalid": "A connector's setup isn't valid.",
  "builder.preflight.blocker.overlay_invalid": "The engine settings (overlay) aren't valid YAML.",
  "builder.preflight.blocker.engine_not_installed":
    "This model's engine isn't available on this site.",
  "builder.preflight.blocker.roster_member_not_found": "A team member ({id}) can't be found.",
  "builder.preflight.blocker.runner_unsupported": "The chosen runner can't serve this agent.",
  "builder.preflight.blocker.mission_required": "Add a goal before you run.",
  "builder.preflight.blocker.memory_scope_unknown": "A memory scope this run joins doesn't exist.",
  "builder.preflight.blocker.run_budget_too_high": "The cap is above the per-run maximum.",
  "builder.preflight.blocker.run_refused": "The engine would refuse this agent: see the checks.",
  "builder.preflight.blocker.other": "Blocked: {code}",
  "builder.preflight.edits.checking": "Checking your edits…",
  "builder.preflight.edits.failed": "Couldn't check your edits.",
  "builder.preflight.edits.refused": "These edits won't save: see the details.",
  "builder.preflight.edits.blocked": "Your edits are blocked on {providers}.",
  "builder.preflight.edits.degraded": "Your edits have warnings on {providers}.",
  "builder.preflight.edits.ok": "Your edits check out.",
  "builder.preflight.gateTitle": "Saving would be refused",
  "builder.preflight.runner.anthropic": "managed agents",
  "builder.preflight.runner.service": "sandbox service",
  "builder.preflight.runner.loop": "server loop",
  "builder.preflight.word.ok": "ok",
  "builder.preflight.word.degraded": "degraded",
  "builder.preflight.word.blocked": "blocked",
  "builder.preflight.word.unchecked": "not checked",
  "builder.preflight.unchecked": "Not checked here: {pairs}",
  "builder.preflight.block.identity": "Name",
  "builder.preflight.block.instructions": "Instructions",
  "builder.preflight.block.goal": "Goal",
  "builder.preflight.block.model": "Model",
  "builder.preflight.block.tools": "Tools",
  "builder.preflight.block.mcp": "Connectors",
  "builder.preflight.block.skills": "Skills",
  "builder.preflight.block.custom_tools": "Custom tools",
  "builder.preflight.block.outcome": "Done looks like",
  "builder.preflight.block.team": "Team",
  "builder.preflight.block.runtime": "Engine settings",
  "builder.preflight.block.run": "The run",
  "canvas.mark.save": "Won't save",
  "builder.mission": "Set goal to",
  "builder.goalSeed": "{mission} — you can use {tools}",
  "builder.outcome": "Done looks like",
  "builder.editorMode": "Editor mode",
  "builder.yamlIntro":
    "This YAML and the blocks describe the same agent.yaml. The server validates both.",
  "builder.yamlLoad": "Generate YAML",
  "builder.yamlApply": "Apply YAML",
  "builder.yamlNotMap": "agent.yaml must be a mapping of keys",
  "builder.codeTabs": "Document",
  "builder.codeTabAgent": "agent.yaml",
  "builder.codeTabOverlay": "overlay",
  "builder.overlay": "Project overlay",
  "builder.overlayIntro":
    "The overlay pins how this project runs: its runner, memory scopes and model seats. It is saved through the same gate as the agent.",
  "builder.overlayEmpty":
    "This project has no overlay yet. Write one here and Apply; Save creates it.",
  "builder.overlayNotMap": "the overlay must be a mapping of keys",
  "builder.opRefused": "An edit can't be saved as written ({reason}). Undo it, or fix it in Code.",
  "builder.saveAndRun": "Save & run",
  "builder.finalizing": "Finalizing outputs…",
  "builder.finalizationFailed": "Some outputs could not be finalized.",
  "builder.viewOutputs": "View outputs ({count})",
  "files.title": "Files",
  "files.subtitle": "Everything this agent uses and creates, in one place.",
  "files.sources": "File sources",
  "files.search": "Search names and paths",
  "files.refresh": "Refresh",
  "files.upload": "Upload file",
  "files.uploadArtifact": "Upload artifact",
  "files.newArtifact": "New artifact",
  "files.newMemory": "New note",
  "files.close": "Close Files",
  "files.source.all": "All",
  "files.source.uploads": "Uploads",
  "files.source.artifacts": "User Artifacts",
  "files.source.skills": "Skills",
  "files.source.logs": "Session Logs",
  "files.source.memory": "Memory",
  "files.source.yaml": "YAML",
  "files.runFilter": "Showing artifacts created by this run.",
  "files.clearRunFilter": "Show all artifacts",
  "files.empty": "No files match this view yet.",
  "files.emptyFinalizing": "Outputs are still being finalized — they'll appear here in a moment.",
  "files.resize": "Resize the file list and preview (drag, or use the arrow keys)",
  "files.select": "Choose a file to see its details and contents.",
  "files.loadMore": "Load more",
  "files.download": "Download",
  "files.edit": "Edit",
  "files.editElsewhere": "Open editor",
  "files.delete": "Delete",
  "files.deleteConfirm": "Delete this item from Files?",
  "files.replaceConfirm": "{name} is already in Files. Replace it?",
  "files.previewUnavailable": "Preview isn't available for this item.",
  "files.previewTruncated": "This is a bounded preview. Download to see the complete file.",
  "files.binaryPreview": "This binary file can't be previewed safely. Download it to view it.",
  "files.preview.markdown": "Formatted document preview",
  "files.preview.code": "Highlighted code preview",
  "files.origin.agent": "Made by agent",
  "files.origin.user": "Uploaded",
  "files.editor.artifact": "User Artifact",
  "files.editor.memory": "Memory note",
  "files.artifactName": "Artifact name",
  "files.memoryPath": "Memory path",
  "files.content": "Content",
  "files.restore": "Restore",
  "files.showArchived": "Show archived memory",
  "files.archived": "Archived",
  "canvas.pill.artifacts": "{count} artifacts",
  "templates.title.mfa": "Template Library",
  "templates.viewAs": "View as",
  "templates.viewAs.all": "All Templates",
  "tpl.subtitle":
    "Start from a ready-made agent. Every template is real YAML you can open and tweak.",
  "tpl.allCategories": "All",
  "tpl.searchLabel": "Search templates",
  "tpl.searchPlaceholder": "Search by name, description or keyword…",
  "tpl.filter.kind": "Team or single",
  "tpl.filter.kind.all": "All",
  "tpl.filter.kind.team": "Teams",
  "tpl.filter.kind.single": "Single agents",
  "tpl.filter.inTeam": "Team membership",
  "tpl.filter.inTeam.any": "Any",
  "tpl.filter.inTeam.yes": "In a team",
  "tpl.filter.inTeam.no": "Standalone",
  "tpl.filter.category": "Category",
  "tpl.filter.industry": "Industry",
  "tpl.filter.collections": "Collections",
  "tpl.filter.capabilities": "Capabilities",
  "tpl.filter.clear": "Clear filters",
  "tpl.filter.showing": "Showing {shown} of {total}",
  "tpl.filter.from": "From",
  "tpl.filter.from.all": "Both sites",
  "tpl.filter.toggle": "Filters{count, plural, =0 {} other { (#)}}",
  "tpl.sort": "Sort",
  "tpl.sort.recommended": "Recommended",
  "tpl.sort.title": "Title A–Z",
  "tpl.sort.newest": "Newest",
  "tpl.noResults.title": "No templates match these filters",
  "tpl.noResults.body": "Try fewer filters or another search.",
  "tpl.card.homeSite": "From {site}",
  "tpl.card.moreChips": "+{count}",
  "tpl.card.team": "Team · {count, plural, one {# member} other {# members}}",
  "tpl.card.members": "Members: {names}{more, plural, =0 {} other { +#}}",
  "tpl.card.alsoInTeam": "Also in team: {name}",
  "tpl.card.inTeams": "In {count} teams",
  "tpl.card.original": "Original",
  "tpl.loading":
    "The template shelf is loading — if this sticks around, the backend may be offline.",
  "tpl.upsellTitle": "Do more with Pro",
  "tpl.upsellBody": "Pro unlocks smarter models and more runs for every template.",
  "tpl.goPro": "Go Pro",
  "tpl.freePlanBadge": "FREE PLAN",
  "tpl.agentYaml": "Agent YAML",
  "tpl.useTemplate": "Use this template →",
  "tpl.seePlans": "See plans →",
  // Template detail (template organization PR-5): team or single, the chip list's name, a
  // team's members and the teams a single sits in. Kept as one block for the PR-4 rebase.
  "tpl.detail.kind.team": "Team · {count, plural, one {# member} other {# members}}",
  "tpl.detail.kind.single": "Single agent",
  "tpl.detail.facets": "Category, industries and keywords",
  "tpl.detail.members": "Members",
  "tpl.detail.usedInTeams": "Used in these teams",
  "profile.choose": "Which model should it use?",
  "profile.runsOn": "runs on {provider}",
  "profile.limitation": "Runs without {capability}",
  "profile.reason.provider_not_installed": "This model isn't available here yet.",
  "provider.anthropic": "Anthropic",
  "provider.openrouter": "OpenRouter",
  "provider.foundry": "Microsoft Foundry",
  "cfg.runsOn": "RUNS ON",
  "templates.empty": "No templates match this profile and language yet.",
  "billing.title.mfa": "Your plan",
  "billing.title.lya": "Workspace plan",
  "billing.plan": "Current plan",
  // 2026-07-28 commerce cutover: the snapshot dashboard's states. Dates are
  // pre-formatted; plan names arrive localized from the server catalog.
  "billing.renewsOn": "Renews on {date}",
  "billing.paidThrough": "Paid through {date}",
  "billing.grace.banner": "There's a payment problem — your plan stays active until {date}.",
  "billing.grace.cta": "Fix payment",
  "billing.scheduled.banner.downgrade": "Your plan changes to {name} on {date}.",
  "billing.scheduled.banner.cadence": "Your billing period changes on {date}.",
  "billing.scheduled.banner.cancel": "Your paid plan ends on {date}.",
  "billing.scheduled.cancelCta": "Keep my current plan",
  "billing.portal.link": "Manage billing & invoices",
  "billing.processing.title": "Finishing your purchase…",
  "billing.processing.body": "We're confirming your payment — this usually takes a few seconds.",
  "billing.processing.still": "Still processing — refresh to check again.",
  "billing.checkout.cancelled": "Checkout was cancelled — no changes were made.",
  "billing.selection.applied": "Your purchase is complete. The plan below is up to date.",
  "billing.selection.failed": "That purchase didn't go through, so your plan hasn't changed.",
  "billing.selection.expired":
    "That checkout expired before it was finished, so your plan hasn't changed.",
  "billing.selection.canceled": "That change was canceled, so your plan hasn't changed.",
  "billing.selection.superseded": "A newer plan choice replaced that one.",
  "billing.selection.unknown":
    "We couldn't find that purchase on this account. The plan below is current.",
  "billing.offerLink.confirm": "Change your plan to {name} at {price}?",
  // Composer attachments. The status ladder is always rendered as TEXT (never
  // colour alone), and the copy describes what the learner is waiting for
  // rather than the provider mechanics behind it.
  "attach.addFiles": "Attach files",
  "attach.chips": "Files you're attaching",
  "attach.status.uploading": "Uploading…",
  "attach.status.preparing": "Adding for the agent…",
  "attach.status.ready": "Ready",
  "attach.status.saved": "Saved for your next job",
  "attach.status.checking": "Checking whether the file was added…",
  "attach.status.removing": "Removing…",
  "attach.status.failed": "Couldn't add this file",
  "attach.retry": "Retry",
  "attach.remove": "Remove",
  "attach.retryFile": "Retry adding {name}",
  "attach.removeFile": "Remove {name}",
  "attach.blockedExplain":
    "Send waits until every attached file is ready for the agent — a moment more.",
  // Team run console (B8): the team panel, lanes, phase bars and the ask dock.
  "builder.team": "Team",
  "run.status.queued": "Queued",
  "run.status.preparing": "Preparing",
  "run.status.starting": "Starting",
  "run.status.running": "Running",
  "run.status.waiting_for_input": "Needs you",
  "run.status.requires_action": "Needs you",
  "run.status.satisfied": "Complete",
  "run.status.needs_revision": "Needs revision",
  "run.status.failed": "Failed",
  "run.status.interrupted": "Stopped",
  "run.status.max_iterations_reached": "Turn limit reached",
  "run.status.unknown": "Finished",
  "history.title": "Run history",
  "history.subtitle": "Every run across your projects, newest first.",
  "history.empty": "No runs yet — run an agent from the Builder.",
  "history.loadMore": "Load more",
  "history.colWhen": "When",
  "history.colProject": "Project",
  "history.colStatus": "Status",
  "history.colWho": "Who",
  "history.colModel": "Model",
  "nav.marketplace": "Marketplace",
  "error.draft_revision_conflict":
    "Someone else saved this draft first. We refreshed to their latest revision — save again to apply your edits.",
  "error.template_key_exists": "A template with this key already exists in the library.",
  "error.template_archived": "This template is archived. Unarchive it to publish again.",
  "error.library_key_exists": "A library with this key already exists.",
  "error.import_has_errors": "This import has validation errors and cannot be applied.",
  "error.import_hash_mismatch": "The uploaded package changed; stage it again before applying.",
  "builder.upgrade.available": "Template update available: v{from} → v{to}.",
  "builder.upgrade.members":
    "{count, plural, one {Team member updated} other {Team members updated}}: {names}.",
  "builder.upgrade.memberVersions": "v{from} → v{to}",
  "builder.upgrade.applyMembers": "Update team members",
  "builder.upgrade.review": "Review update",
  "builder.upgrade.auto": "updates automatically",
  "builder.upgrade.conflict": "you changed this too — pick one:",
  "builder.upgrade.keepMine": "Keep mine",
  "builder.upgrade.takeTemplate": "Take template",
  "builder.upgrade.apply": "Apply v{version}",
  "builder.upgrade.chooseFirst": "Resolve every conflicting section before applying.",
  "builder.upgrade.saveFirst": "Save your changes before upgrading.",
  "builder.upgrade.starterFiles": "starter files",
  "builder.upgrade.starterFilesAdded":
    "adds {count, plural, one {one file} other {# files}} to your uploads: {names} (a file you already have keeps your copy)",
  "error.upgrade_choices_required": "Pick a side for each conflicting section first.",
  // ---- public shell (V1 splash/pricing/catalog port) ----
  "publicNav.templates": "Templates",
  "publicNav.pricing": "Plans & Billing",
  "publicNav.signIn": "Sign in",
  "publicNav.startFree": "Start free",
  "splash.badge.mfa": "Made for first-time builders",
  "splash.badge.lya": "For founders & teams",
  "splash.hero1.mfa": "Build your first",
  "splash.hero2.mfa": "AI agent.",
  "splash.hero1.lya": "Launch your own",
  "splash.hero2.lya": "AI agents.",
  "splash.sub.mfa":
    "Snap blocks together, give it a mission, and watch a real AI agent go to work — thinking, using tools, and getting things done.",
  "splash.sub.lya":
    "Design an agent, hand it a job, and watch a real AI agent go to work — thinking, using your tools, and delivering results.",
  "splash.ctaTemplates": "See templates",
  "splash.ctaPlans": "See the plans",
  "splash.trust.lya": "No credit card • Start free, cancel anytime",
  "splash.blocks.when": "when Run is clicked",
  "splash.blocks.goal": "set goal to",
  "splash.blocks.goalValue": "explore Mars 🚀",
  "splash.blocks.repeat": "repeat until",
  "splash.blocks.repeatValue": "answer is ready",
  "splash.blocks.tool": "use a tool",
  "splash.blocks.show": "show the answer",
  "splash.feature1.title.mfa": "Snap blocks together",
  "splash.feature1.body.mfa":
    "Build the agent's brain visually. Flip to Code any time to see the real thing.",
  "splash.feature2.title.mfa": "Watch it really work",
  "splash.feature2.body.mfa":
    "A real AI agent runs your mission live — thinking out loud, using tools, checking in.",
  "splash.feature3.title.mfa": "Level up with templates",
  "splash.feature3.body.mfa":
    "Start from a ready-made agent, tweak the YAML, and make it your own.",
  "splash.feature1.title.lya": "Design it your way",
  "splash.feature1.body.lya":
    "Compose the agent visually or in YAML — the spec is always the real thing.",
  "splash.feature2.title.lya": "Watch it really work",
  "splash.feature2.body.lya":
    "A real AI agent runs the job live — reasoning, using your tools, reporting back.",
  "splash.feature3.title.lya": "Start from templates",
  "splash.feature3.body.lya": "Begin with a proven agent, adapt it to your workflow, and ship it.",
  // ---- MFA-only splash (owner spec 2026-07-26; hero field IS wizard Step 1) ----
  "mfaSplash.nav.how": "How it works",
  "mfaSplash.nav.pricing": "Pricing",
  "mfaSplash.nav.logIn": "Log in",
  "mfaSplash.badge": "YOUR FIRST AGENT · FREE TO START",
  "mfaSplash.hero.title": "Your first AI agent is one sentence away.",
  "mfaSplash.hero.sub":
    "Say what it should do. Watch it snap together out of real blocks. Then boss it around. Sign in free — building starts right after.",
  "mfaSplash.prompt.label": "WHAT SHOULD YOUR AGENT DO?",
  "mfaSplash.prompt.build": "Build it →",
  "mfaSplash.prompt.note": "Free Spark plan at sign-in — no credit card, honest limits.",
  "mfaSplash.chip.1": "Quiz me on space facts",
  "mfaSplash.chip.2": "Sort my downloads into folders",
  "mfaSplash.chip.3": "Make trivia for game night",
  "mfaSplash.chip.4": "Invent a bedtime story machine",
  "mfaSplash.how.title": "Three steps. Zero manuals.",
  "mfaSplash.how.1.t": "Say it",
  "mfaSplash.how.1.d": "One sentence, any idea. No wrong answers and no manuals.",
  "mfaSplash.how.2.t": "Watch it build",
  "mfaSplash.how.2.d":
    "Your agent snaps together out of real blocks — a goal, a brain, skills. Tap Code to see what's really inside.",
  "mfaSplash.how.3.t": "Boss it around",
  "mfaSplash.how.3.d":
    "Hit Run. Your agent thinks out loud, does the work, and shows you every step.",
  "mfaSplash.tpl.title": "No idea yet? Grab a ready-made agent.",
  "mfaSplash.tpl.sub": "Every template is real code you can open, run, and tweak.",
  "mfaSplash.tpl.kids": "Starter",
  "mfaSplash.tpl.teens": "Advanced",
  "mfaSplash.tplName.aiPet": "AI Pet",
  "mfaSplash.tplName.showdown": "Animal Superpower Showdown",
  "mfaSplash.tplName.poem": "Poem File Writer",
  "mfaSplash.tplName.web": "Web Page Explainer",
  "mfaSplash.tplName.aiBoss": "AI Boss",
  "mfaSplash.tplName.inspector": "App Safety Inspector",
  "mfaSplash.tplName.data": "Data Analyst",
  "mfaSplash.tplName.sheets": "Spreadsheet Builder",
  "mfaSplash.tpl.aiPet": "A playful AI companion that runs learning quests and creative missions.",
  "mfaSplash.tpl.showdown": "Pit real animal abilities against each other and crown a champion.",
  "mfaSplash.tpl.poem": "Turns anything — your day, your dog — into poems it saves as files.",
  "mfaSplash.tpl.web": "Reads any page and explains it in words that actually make sense.",
  "mfaSplash.tpl.aiBoss": "Direct AI work like a project lead — plan, delegate, verify, ship.",
  "mfaSplash.tpl.inspector": "Learn why apps ask for permissions and judge if one is safe.",
  "mfaSplash.tpl.data": "Crunch spreadsheets and find the story hiding in the numbers.",
  "mfaSplash.tpl.sheets": "Describe a tracker or a budget — get a working spreadsheet back.",
  "mfaSplash.tag.create": "create",
  "mfaSplash.tag.research": "research",
  "mfaSplash.tag.security": "security",
  "mfaSplash.tag.code": "code",
  "mfaSplash.pricing.title": "Start free. Upgrade when you outgrow it.",
  "mfaSplash.pricing.sub": "Spark is free forever. Paid plans add bigger brains and more runs.",
  "mfaSplash.pricing.free": "free forever",
  "mfaSplash.pricing.perMonth": "per month",
  "mfaSplash.pricing.start": "START HERE",
  "mfaSplash.pricing.popular": "MOST POPULAR",
  "mfaSplash.pricing.cta": "See full pricing →",
  "mfaSplash.pricing.annualAvailable": "Annual billing is available on paid plans.",
  "mfaSplash.footer.navLabel": "Footer",
  "mfaSplash.footer.tagline": "Built for first agents. Ready for real work.",
  "mfaSplash.footer.privacy": "Privacy",
  "mfaSplash.footer.terms": "Terms",
  "mfaSplash.footer.copyright": "© 2026 New Machine, Inc.",
  "notFound.title": "Page not found",
  "notFound.body":
    "There is nothing at this address. The link may be old, or the page may have moved.",
  "notFound.home": "Go to the home page",
  "notFound.templates": "Go to templates",
  "error.chunkTitle": "This part of the app did not load",
  "error.chunkBody": "Your connection may have dropped while it was downloading. Try again.",
  "pricing.title": "Plans & Billing",
  "pricing.cta.start": "Start free",
  "pricing.cta.current": "Current plan",
  "pricing.cta.free": "Switch to Free",
  "pricing.cta.downgrade": "Downgrade",
  "pricing.cta.get": "Get {name}",
  "pricing.cta.switchAnnual": "Switch to annual",
  "pricing.cta.switchMonthly": "Switch to monthly",
  "pricing.cta.unavailable": "Coming soon",
  "pricing.confirmDowngrade": "Switch down to {name}?",
  "error.unknown_offer": "That offer isn't available here.",
  "error.plan_not_found": "That plan isn't available to switch to.",
  "error.admin_required": "This action needs an admin account.",
  "error.plan_switch_live_subscription":
    "This account has a live subscription — cancel it in the billing portal before switching.",
  "error.plan_switch_pending_change":
    "A plan change is already in flight — let it finish or cancel it first.",
  "pricing.badge.testing": "Testing this plan",
  "error.pending_change_exists": "A plan change is already scheduled — cancel it first.",
  "error.billing_unavailable": "Billing isn't available right now — try again soon.",
  "error.change_not_found": "That scheduled change no longer exists.",
  "error.billing_customer_not_found": "We couldn't find your billing details — contact support.",
  "planGrid.perMonth": "/month",
  "catalog.signInToUse": "Sign in to use",
  "catalog.back": "All templates",
  "account.profile": "Profile",
  "wizard.cta.title": "Not sure where to start?",
  "wizard.cta.body": "Answer a few questions and we'll build your first agent together.",
  "wizard.cta.button": "Start the guided builder →",
  "wizard.title": "Build your first agent",
  "wizard.step": "Step {current} / {total}",
  "wizard.next": "Next →",
  "wizard.create": "Create my agent",
  "wizard.retryDraft": "Finish setting up",
  "wizard.idea.title": "What should your agent do?",
  "wizard.idea.placeholder": "I want an agent that…",
  "wizard.details.title": "What would a great first version do?",
  "wizard.details.placeholder": "A great first version would…",
  "wizard.shape.title": "Who is it for, and what should it make?",
  "wizard.audience.me": "Me",
  "wizard.audience.team": "A team",
  "wizard.audience.customers": "Customers",
  "wizard.output.brief": "Short brief",
  "wizard.output.brief.desc": "A scan-friendly answer.",
  "wizard.output.checklist": "Checklist",
  "wizard.output.checklist.desc": "Steps or tasks to follow.",
  "wizard.output.file": "Saved file",
  "wizard.output.file.desc": "A file the agent writes.",
  "wizard.output.message": "Draft message",
  "wizard.output.message.desc": "Ready to paste or send later.",
  "wizard.tools.title": "What can it use?",
  "wizard.tools.web": "Web search",
  "wizard.tools.web.desc": "Use current sources.",
  "wizard.tools.files": "Files",
  "wizard.tools.files.desc": "Read uploaded files.",
  "wizard.tools.write": "Write outputs",
  "wizard.tools.write.desc": "Create files and results.",
  "wizard.brief.title": "Your agent brief",
  "wizard.brief.agent": "Agent",
  "wizard.brief.model": "Model",
  "wizard.model.default": "Pick for me",
  "wizard.brief.tools": "Tools",
  "wizard.brief.output": "Output",
  "wizard.brief.outcome": "Done looks like",
  "wizard.brief.next": "Good next steps",
  "wizard.next.run": "Run it once, tighten the outcome, then save the best result.",
  "wizard.compose.role": "You are a careful, friendly agent created from a guided questionnaire.",
  "wizard.compose.job": "Job: {idea}",
  "wizard.compose.context": "More context: {details}",
  "wizard.compose.audience": "Audience: {audience}.",
  "wizard.compose.output": "Output: {output}.",
  "wizard.compose.askFirst":
    "When information is missing, ask a clear question instead of guessing.",
  "wizard.outcome.summary": "Done looks like: {idea}",
  "wizard.outcome.goal": "Completes the user goal: {idea}",
  "wizard.outcome.useful": "Produces a useful {output} for {audience}",
  "wizard.outcome.explain": "Explains what it did and calls out any missing information",
  // --- LYA corporate rebrand (2026-07): professional counterparts of keys
  // whose MFA voice is kid/family-specific. The .mfa twins above keep MFA
  // byte-identical; these render only on launchyouragent.
  "auth.kidsNote.lya": "Your workspace data stays private — we never sell it.",
  "auth.emailLabel.lya": "Work email",
  "mcpLib.comingSoon.lya": "Connection coming soon.",
  "grader.detail.text-judge.lya":
    "An LLM judge scores the writing: clarity, correctness, and fit for the audience.",
  "templates.title.lya": "Template Library",
  // --- 2026-07-25 plans handoff (design_handoff_plans_billing): page chrome
  // for the catalog-driven PricingPlans screen. Catalog copy (plan names,
  // blurbs, features, credit notes, offer notes, guide chips) is server-side
  // in the billing presentation records since the 2026-07-28 commerce cutover.
  "pricing.subhead.lya.plans":
    "Usage is pooled across your workspace — every run uses Anthropic's Claude models.",
  "pricing.subhead.mfa.plans":
    "Every plan runs on Anthropic's Claude models — bigger plans unlock smarter models and more runs.",
  "pricing.billing.label": "Billing period",
  "pricing.billing.monthly": "Monthly",
  "pricing.billing.annual": "Annual",
  "pricing.billedMonthly": "billed monthly",
  "pricing.perYear": "/year",
  "pricing.free": "Free",
  "pricing.freeNote": "no credit card needed",
  "pricing.models.label": "Claude models",
  "pricing.cta.upgrade": "Upgrade",
  "pricing.district.title": "Whole team or company?",
  "pricing.district.body":
    "Custom seats, SSO, rostering and invoicing — we'll build a quote with you.",
  "pricing.district.cta": "Talk to us",
  "pricing.footnote.lya":
    "All plans run on Anthropic Claude models · Prices in USD · Cancel anytime",
  "pricing.footnote.mfa":
    "All plans run on Anthropic Claude models · Prices in USD · Cancel anytime",
  "nav.admin": "Admin dashboard (internal)",
  // --- Developer tools (dev only; the server publishes devTools in runtime config).
  "devtools.menu": "Developer tools",
  "devtools.dashboard.title": "Developer tools",
  "devtools.dashboard.subtitle":
    "Dev-only views of this site: its API procedures, your recent runs and your projects.",
  "devtools.tabs": "Developer tools sections",
  "devtools.tab.overview": "Overview",
  "devtools.tab.rpc": "RPC",
  "devtools.tab.runs": "Runs",
  "devtools.signInPrompt":
    "Runs and projects belong to an account: sign in to see yours. The RPC tab works signed out.",
  "devtools.overview.environment": "This session",
  "devtools.overview.site": "site: {site}",
  "devtools.overview.role": "role: {role}",
  "devtools.overview.build": "build: {build}",
  "devtools.picker.runs": "Recent runs",
  "devtools.picker.noRuns": "No runs on this account yet.",
  "devtools.picker.colRun": "Run",
  "devtools.picker.colProject": "Project",
  "devtools.picker.colStatus": "Status",
  "devtools.picker.colModel": "Model",
  "devtools.picker.colRunner": "Runner",
  "devtools.picker.colStarted": "Started",
  "devtools.picker.colSandboxTime": "Sandbox time (estimate)",
  "devtools.picker.colSandboxTimeHint":
    "Runs on the sandbox path: the sandbox's awake time, its windows and an Azure estimate at list price. Not charged.",
  "devtools.picker.projects": "Projects",
  "devtools.picker.noProjects": "No projects on this account yet.",
  "devtools.picker.projectMeta": "revision {revision} · updated {updated}",
  "devtools.runs.back": "Back to the list",
  "devtools.notFound.run": "No run with this id is visible to this account.",
  "devtools.notFound.project": "No project with this id is visible to this account.",
  "devtools.run.title": "Run {id}",
  "devtools.run.status": "Status",
  "devtools.run.stopReason": "Stop reason",
  "devtools.run.agent": "Agent",
  "devtools.run.model": "Model",
  "devtools.run.profile": "Profile",
  "devtools.run.runner": "Runner",
  "devtools.run.runnerReasons": "(the service lacks: {reasons})",
  "devtools.run.cost": "Cost",
  "devtools.run.costUnavailable": "unavailable",
  "devtools.run.usageState": "(usage {state}, settled: {settled})",
  "devtools.run.runtimeCharged": "Runtime (charged)",
  "devtools.run.sandboxTime": "Sandbox time (Azure estimate, not charged)",
  "devtools.sandboxTime.value":
    "{awake} · {windows, plural, one {# window} other {# windows}} · ~{usd}",
  "devtools.sandboxTime.detail":
    "({estimated, plural, =0 {every end observed} one {# end estimated} other {# ends estimated}}{open, select, true {, a window open} other {}}; tier {tier})",
  "devtools.sandboxTime.tooltip":
    "Sandbox time: an Azure estimate at list price over the sandbox's awake windows, idle minutes before the 300 s suspend included. Not charged. Runtime (charged): {runtime}.",
  "devtools.sandboxTime.last24h":
    "Sandbox sessions in the last 24 h: {sessions} · awake {awake} · {windows, plural, one {# window} other {# windows}} · ~{usd} (Azure estimate, not charged)",
  "devtools.run.finalization": "Finalization",
  "devtools.run.providerStatus": "Provider session",
  "devtools.run.started": "Started",
  "devtools.run.project": "Project",
  "devtools.run.openProject": "Open project",
  "devtools.run.capabilities": "What the run allows (read-only)",
  "devtools.run.capabilityOn": "{name}: yes",
  "devtools.run.capabilityOff": "{name}: no",
  "devtools.connection": "Connection: {state}",
  "devtools.connection.connecting": "connecting",
  "devtools.connection.live": "live",
  "devtools.connection.polling": "live (polling)",
  "devtools.connection.reconnecting": "reconnecting",
  "devtools.connection.retryingHistory": "retrying history",
  "devtools.connection.ended": "ended",
  "devtools.connection.error": "error",
  "devtools.events.title": "Events",
  "devtools.events.type": "Type",
  "devtools.events.source": "Source",
  "devtools.events.allTypes": "All types",
  "devtools.events.allSources": "All sources",
  "devtools.events.count": "Showing {shown} of {total}",
  "devtools.events.showMore": "Show more",
  "devtools.events.empty": "No events yet.",
  "devtools.events.noMatch": "No events match these filters.",
  "devtools.events.truncated": "More than {max} events: only the newest {max} are kept here.",
  "devtools.outputs.title": "Outputs",
  "devtools.outputs.empty": "This run has no deliverables.",
  "devtools.outputs.notLive": "This run's session is gone, so its deliverables can't be listed.",
  "devtools.outputs.preview": "Preview",
  "devtools.outputs.hide": "Hide preview",
  "devtools.outputs.binary": "Binary file: download it to open.",
  "devtools.outputs.download": "Download",
  "devtools.project.openBuilder": "Open in the Builder",
  "devtools.project.runs": "Runs",
  "devtools.project.noRuns": "No runs for this project yet.",
  "devtools.preflight.title": "Preflight",
  "devtools.preflight.note":
    "Preflight checks only local conditions. Provider availability, Claude Managed Agents acceptance and live MCP discovery stay unknown until the run starts.",
  "devtools.preflight.mission": "Mission (optional)",
  "devtools.preflight.budget": "Budget in dollars (optional)",
  "devtools.preflight.budgetInvalid": "Enter an amount between $0.01 and $10,000.",
  "devtools.preflight.check": "Check",
  "devtools.preflight.checking": "Checking…",
  "devtools.preflight.result": "Preflight result",
  "devtools.preflight.ready": "Ready",
  "devtools.preflight.blocked": "Blocked",
  "devtools.preflight.facts": "revision {revision} · engine {engine} · checked {checkedAt}",
  "devtools.preflight.engineMissing": "none chosen",
  "devtools.preflight.engineNotInstalled": "{engine} (not installed)",
  "devtools.preflight.mission.input": "Mission: from the input",
  "devtools.preflight.mission.goal": "Mission: the project's goal",
  "devtools.preflight.mission.missing": "Mission: missing",
  "devtools.preflight.budgetLine": "Budget: {amount}",
  "devtools.preflight.budgetDefault": "Budget: {amount} (the default)",
  "devtools.preflight.blockers": "Blockers",
  "devtools.preflight.enforced": "Enforced",
  "devtools.preflight.enforcedHint": "A failing enforced finding refuses the start.",
  "devtools.preflight.advisory": "Advisory",
  "devtools.preflight.advisoryHint":
    "Claude Managed Agents does not run these checks when a run starts, so they never block one there. They show what the checker would say.",
  "devtools.preflight.noFindings": "None.",
  "devtools.preflight.agents": "Agents",
  "devtools.preflight.profiles": "Model profiles",
  "devtools.preflight.probedOn": "probed {date}",
  "devtools.preflight.stale": "stale",
  "devtools.preflight.warnings": "Compile warnings",
  "devtools.preflight.unchecked": "Not checked",
  "devtools.inspect.title": "Inspect",
  "devtools.inspect.run": "Inspect run {id}",
  "devtools.inspect.project": "Open project {id}",
  "devtools.subtitle":
    "Every procedure the contract declares, executed through the app's own client — same cookies, same headers, as you.",
  "devtools.anonymousBanner":
    "You are signed out, so calls run anonymously. Sign in to exercise the procedures that need a session.",
  "devtools.procedures": "Procedures",
  "devtools.badges": "Procedure facts",
  "devtools.badge.public": "works signed out",
  "devtools.badge.session": "needs a session",
  "devtools.badge.idempotency": "Idempotency-Key from requestId",
  "devtools.badge.sessionChanging": "session-changing",
  "devtools.inputSchema": "Input schema",
  "devtools.outputSchema": "Output schema",
  "devtools.input": "Input (JSON)",
  "devtools.noInput": "This procedure takes no input.",
  "devtools.parseError": "The input is not valid JSON: {message}",
  "devtools.idempotencyKey": "Idempotency-Key header: {value}",
  "devtools.idempotencyMissing": "(set requestId in the input)",
  "devtools.newRequestId": "New requestId",
  "devtools.execute": "Execute",
  "devtools.running": "Running…",
  "devtools.sessionChangingNote":
    "Changes the session cookie — use the app's sign-in/sign-out instead.",
  "devtools.success": "Success",
  "devtools.result": "Result",
  "devtools.errorResult": "Error response",
  "devtools.timing": "{ms} ms (headers {headersMs} ms)",
  "devtools.networkError": "The request never got an answer: {message}",
  "devtools.raw.title": "Raw HTTP",
  "devtools.raw.request": "Request",
  "devtools.raw.response": "Response",
  "devtools.raw.redacted": "[redacted]",
  "devtools.raw.browserAdded": "(added by the browser)",
  "devtools.raw.cookieExpected":
    "{name}=… expected (added by the browser; the HttpOnly value is never readable here)",
  "devtools.raw.originNote":
    "A write that carries a session cookie must send this site's own Origin, or the server refuses it (the CSRF rule).",
  "devtools.raw.noBody": "(no body)",
  "devtools.raw.noResponse": "No response: the request never got an answer.",
  "devtools.raw.eventStream": "Event stream: headers only.",
  "devtools.raw.truncated": "Showing the first {kb} KB; the rest of the body was not read.",
  "devtools.raw.copyCurl": "Copy as curl",
  "devtools.raw.copyWarning": "May contain account data — don't paste into tickets or chat.",
  "devtools.raw.copied": "Copied.",
  "devtools.raw.copyFallback": "Copying is unavailable here; select the command below.",
  "devtools.examples.load": "Load input…",
  "devtools.examples.examples": "Examples",
  "devtools.examples.saved": "Saved",
  "devtools.examples.skeleton": "Empty skeleton",
  "devtools.examples.templateOption": "{name} (Input template — fill in ids)",
  "devtools.examples.saveAs": "Save as…",
  "devtools.examples.save": "Save",
  "devtools.examples.delete": "Delete “{name}”",
  "devtools.examples.notStored": "Inputs for this procedure are never saved.",
  "devtools.examples.storageHint":
    "Saved inputs are stored with your account for this site (dev tools only). Don't save anything secret.",
  "devtools.examples.notSaved.signedOut":
    "Not saved: signed out, inputs last for this tab only. Sign in to keep them.",
  "devtools.examples.notSaved.unavailable":
    "Not saved: storage is unavailable right now, so inputs last for this tab only.",
  "devtools.examples.notSaved.refused":
    "Not saved: your saved inputs are over the account's limits ({totalKb} KB in all), so the latest changes last for this tab only. Delete some to save them.",
  "devtools.examples.outcome.saved": "Saved.",
  "devtools.examples.outcome.refused": "Inputs for this procedure are never saved.",
  "devtools.examples.outcome.badName": "Name it with 1 to {length} characters.",
  "devtools.examples.outcome.tooLarge": "Too large to save (the limit is {kb} KB).",
  "devtools.examples.outcome.full":
    "This procedure already has {count} saved inputs. Delete one first.",
  "devtools.examples.outcome.noRoom":
    "No room: your saved inputs are limited to {totalKb} KB in all. Delete some first.",
  "devtools.examples.placeholderHint":
    "This input still has a placeholder in angle brackets: replace it with a real id from the named call before executing.",
  "devtools.examples.mismatch": "Doesn't match the input schema: {issues}",
  "devtools.developersLink":
    "The same procedures and routes, with the OpenAPI document, for anyone: {link}.",
  "apiKeys.reference": "What a key can call, with the OpenAPI document: {link}.",
  "developers.nav": "Developers",
  "developers.eyebrow": "API reference",
  "developers.title": "Developers",
  "developers.intro":
    "Everything the site does, a script can do too. The API under {prefix} serves every procedure and route on this page to a script, a command-line tool or another front-end, as plain JSON over HTTPS.",
  "developers.version": "Wire {wire}, version {version}",
  "developers.versionLoading": "Reading the wire's version…",
  "developers.versionOffline":
    "The served document could not be read just now; this page describes version {version}, the one it was built with.",
  "developers.document": "OpenAPI document",
  "developers.documentNote":
    "OpenAPI 3.1, generated from the contracts: every call on this page with its schemas, the access a key needs and the one error body. Public, from any origin. Give it to a client generator or to an assistant.",
  "developers.credentials.title": "Credentials",
  "developers.credentials.body":
    "An account key, minted on your profile page and shown once, goes in an Authorization: Bearer header or in X-Api-Key. A read key can look at templates, projects and runs; a write key can also save projects and start runs. A key is a secret: keep it in an environment variable on a server or a laptop, never in a page. A front-end on an allowed origin holds a bearer session instead, and the site's own pages use its cookie.",
  "developers.credentials.link": "Manage your API keys",
  "developers.quickstart.title": "Quickstart",
  "developers.quickstart.curl": "With curl",
  "developers.quickstart.curlNote":
    "Placeholders in angle brackets are yours to fill. The key comes from the environment; this page never shows one.",
  "developers.quickstart.cli": "With the v5 command line",
  "developers.quickstart.cliNote":
    "The reference client, built from the repository: it lists the catalog, starts and follows a run, answers its questions and saves what it made.",
  "developers.procedures.title": "Procedures",
  "developers.procedures.body":
    "Every procedure is POST {prefix}/{area}/{name}: the input as the JSON body ({empty} or no body when it takes none) and the output as the JSON answer. A refusal answers at its HTTP status with one error body: code, status, message, data and traceId.",
  "developers.procedures.none": "no input",
  "developers.schema.input": "Input schema",
  "developers.schema.output": "Output schema",
  "developers.access.read": "read",
  "developers.access.write": "write",
  "developers.access.public": "works without a credential",
  "developers.access.noKeys": "no keys",
  "developers.access.cookieOnly": "site cookie only",
  "developers.access.idempotencyRequired": "Idempotency-Key required",
  "developers.access.idempotencyOptional": "Idempotency-Key honoured",
  "developers.access.sessionChanging": "sets or clears the session cookie",
  "developers.routes.title": "Routes",
  "developers.routes.body":
    "The hand-written routes beside the procedures: a run's live event stream, a deliverable's or an upload's bytes, uploads, the catalog snapshot and the document itself. Each answers at its own path, in its own media type.",
  "developers.routes.method": "Method",
  "developers.routes.path": "Path",
  "developers.routes.summary": "What it does",
  "developers.routes.access": "Access",
  "developers.routes.media": "Answers",
  "developers.footnote":
    "Within {prefix} the wire changes only by addition: new procedures, optional inputs, output fields and enum members. A client ignores what it does not know. Every answer carries the {header} header with the wire's version; a breaking change would ship beside v5, never in place.",
} as const;

export type MessageId = keyof typeof en;

export const es: Record<MessageId, string> = {
  "common.loading": "Cargando tu estudio…",
  "common.retry": "Intentar de nuevo",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.save": "Guardar",
  "common.saving": "Guardando…",
  "common.create": "Crear",
  "common.creating": "Creando…",
  "common.open": "Abrir",
  "common.delete": "Eliminar",
  "common.back": "Volver",
  "common.language": "Idioma",
  "common.english": "Inglés",
  "common.spanish": "Español",
  "nav.dashboard": "Inicio",
  "nav.templates": "Plantillas",
  "nav.billing": "Planes",
  "nav.skip": "Saltar al contenido principal",
  "nav.primary": "Navegación principal",
  "nav.builder": "Constructor",
  "nav.history": "Historial",
  "menu.workspace": "Vistas del espacio",
  "menu.build": "Crear e inspeccionar",
  "menu.account": "Cuenta",
  "menu.testPlan": "{plan} · plan de prueba",
  "auth.eyebrow.mfa": "Un lugar seguro para crear algo increíble",
  "auth.eyebrow.lya": "El estudio de agentes profesional",
  "auth.hero.mfa": "Las grandes ideas empiezan con un bloque brillante.",
  "auth.hero.lya": "Pon a trabajar agentes de IA para tu equipo.",
  "auth.or": "o",
  "auth.welcomeTitle": "¡Bienvenido de nuevo!",
  "auth.welcomeSub": "Inicia sesión para seguir creando",
  "auth.createTitle": "Crea tu cuenta",
  "auth.createSub": "Empieza a crear agentes en segundos",
  "auth.tab.signIn": "Iniciar sesión",
  "auth.tab.create": "Crear cuenta",
  "auth.kidsNote.mfa": "Los datos de tu espacio de trabajo son privados: nunca los vendemos.",
  "auth.title": "Inicia sesión en {brand}",
  "auth.body.mfa":
    "Inicia sesión para crear, ejecutar y dirigir agentes de IA reales en tu propio espacio.",
  "auth.body.lya":
    "Los gerentes inician sesión para diseñar agentes y dirigir ejecuciones reales de agentes.",
  "auth.google": "Continuar con Google",
  "auth.emailLabel.mfa": "Correo electrónico",
  "auth.emailPlaceholder": "tu@ejemplo.com",
  "auth.required":
    "Debes iniciar sesión. Las ejecuciones nunca usan una demostración o simulación.",
  "auth.configMissing":
    "El acceso no está configurado en este entorno. Pide al administrador que agregue la configuración pública de Firebase V2.",
  "auth.error": "No pudimos iniciar tu sesión. Inténtalo de nuevo.",
  "auth.signOut": "Cerrar sesión",
  "auth.busy": "Un momento…",
  "auth.nameLabel": "Tu nombre",
  "auth.namePlaceholder": "Tu nombre",
  "auth.passwordLabel": "Contraseña",
  "auth.passwordPlaceholder": "••••••••",
  "auth.password.show": "Mostrar",
  "auth.password.hide": "Ocultar",
  "auth.password.toggleTitle": "Mostrar u ocultar tu contraseña",
  "auth.forgot": "¿Olvidaste tu contraseña?",
  "auth.cta.signIn": "Iniciar sesión",
  "auth.cta.create": "Crear cuenta",
  "auth.verifyNotice":
    "📬 Revisa tu correo para verificar tu email: enviamos un enlace de confirmación al crear la cuenta.",
  "auth.reset.title": "Restablece tu contraseña",
  "auth.reset.sub": "Dinos tu correo y te enviaremos un enlace",
  "auth.reset.cta": "Enviarme un enlace de restablecimiento",
  "auth.reset.sent": "Si {email} tiene una cuenta, un enlace de restablecimiento va en camino.",
  "auth.reset.back": "Volver a iniciar sesión",
  "auth.err.email_in_use": "Ese correo ya tiene una cuenta — cambia a Iniciar sesión.",
  "auth.err.bad_email": "Eso no parece una dirección de correo.",
  "auth.err.weak_password": "Elige una contraseña más larga (al menos 6 caracteres).",
  "auth.err.bad_credentials": "El correo o la contraseña no coinciden — inténtalo de nuevo.",
  "auth.err.email_provider_disabled":
    "El acceso por correo aún no está activado — usa Google por ahora.",
  "auth.err.google_provider_disabled":
    "El acceso con Google aún no está activado — usa el correo por ahora.",
  "auth.err.too_many_attempts": "Demasiados intentos — espera un minuto e inténtalo de nuevo.",
  "auth.err.popup_blocked":
    "Tu navegador bloqueó la ventana de Google — permite ventanas emergentes e inténtalo de nuevo.",
  "auth.err.popup_closed": "La ventana de Google se cerró antes de terminar — inténtalo de nuevo.",
  "auth.err.unauthorized_domain":
    "El acceso no está permitido desde esta dirección web todavía — pide a quien administra este sitio que la autorice.",
  "auth.err.bad_continue_url":
    "No pudimos enviar el correo — esta dirección web aún no está autorizada. Pide a quien administra este sitio que lo arregle.",
  "auth.err.firebase_not_configured": "El acceso no está configurado en esta instalación.",
  "auth.err.expired_link": "Ese enlace caducó — pide uno nuevo e inténtalo de nuevo.",
  "auth.err.invalid_link": "Ese enlace ya no es válido — puede que ya se haya usado.",
  "auth.err.account_disabled":
    "Esta cuenta está deshabilitada. Contacta con soporte si crees que es un error.",
  "auth.err.network":
    "No pudimos conectar con el servicio de acceso — revisa tu conexión e inténtalo de nuevo.",
  "auth.err.no_firebase_session":
    "Tu sesión de acceso no está disponible en este navegador — cierra sesión, vuelve a entrar e inténtalo de nuevo.",
  "auth.err.enter_name": "Escribe primero tu nombre.",
  "auth.err.password_mismatch": "Las contraseñas no coinciden — escribe la misma dos veces.",
  "auth.err.unknown": "El acceso no funcionó — inténtalo de nuevo.",
  "release.banner.body": "Hay una versión nueva del sitio.",
  "release.banner.reload": "Recargar",
  "release.banner.dismiss": "Descartar",
  "auth.banner.title": "Verifica tu correo.",
  "auth.banner.body":
    "Enviamos un enlace de confirmación a {email}. Mientras tanto puedes seguir creando.",
  "auth.banner.resend": "Reenviar correo de verificación",
  "auth.banner.resent": "¡Enviado! Revisa tu bandeja.",
  "auth.banner.check": "Ya verifiqué — comprobar de nuevo",
  "auth.banner.stillUnverified": "Aún sin verificar — primero haz clic en el enlace del correo.",
  "auth.banner.noSession":
    "No podemos reenviarlo desde este navegador. Cierra sesión, vuelve a entrar e inténtalo desde aquí.",
  "auth.action.working": "Comprobando tu enlace…",
  "auth.action.verifiedTitle": "¡Correo verificado!",
  "auth.action.verifiedBody": "Gracias — tu dirección de correo está confirmada.",
  "auth.action.continue": "Continuar",
  "auth.action.goSignIn": "Ir a iniciar sesión",
  "auth.action.resetTitle": "Elige una contraseña nueva",
  "auth.action.resetFor": "para {email}",
  "auth.action.newPasswordLabel": "Contraseña nueva",
  "auth.action.confirmPasswordLabel": "Escríbela otra vez",
  "auth.action.resetCta": "Guardar contraseña nueva",
  "auth.action.resetDoneTitle": "¡Contraseña actualizada!",
  "auth.action.resetDoneBody":
    "Iniciaste sesión con tu contraseña nueva. Las demás sesiones se cerraron.",
  "auth.action.resetDoneSignIn": "Inicia sesión con tu contraseña nueva para seguir creando.",
  "auth.action.recoverTitle": "Correo restaurado",
  "auth.action.recoverBody":
    "Tu correo de acceso vuelve a ser {email}. Si no pediste este cambio, restablece tu contraseña ahora.",
  "auth.action.recoverBodyNoEmail":
    "Tu correo de acceso fue restaurado. Si no pediste este cambio, restablece tu contraseña ahora.",
  "auth.action.recoverReset": "Restablecer contraseña ahora",
  "auth.action.expiredTitle": "Este enlace caducó",
  "auth.action.expiredBody":
    "Los enlaces solo funcionan por un tiempo corto. Pide uno nuevo e inténtalo otra vez.",
  "auth.action.invalidTitle": "Este enlace no es válido",
  "auth.action.invalidBody":
    "Puede que haya caducado o que ya se haya usado. Pide un enlace nuevo e inténtalo otra vez.",
  "account.setPassword": "Crear o restablecer contraseña",
  "account.passwordEmailSent": "Correo de restablecimiento enviado a {email}",
  "error.identity_email_conflict":
    "Otra cuenta ya usa este correo verificado. Inicia sesión con el método original de esta dirección.",
  "site.invalidTitle": "Este sitio no está configurado",
  "site.invalidBody": "El dominio actual no corresponde a My First Agent ni Launch Your Agent.",
  "site.mismatchTitle": "El contexto del sitio no coincide",
  "site.mismatchBody": "Por tu seguridad, esta cuenta no puede abrirse en esta dirección.",
  "error.backendTitle": "El estudio no pudo conectarse",
  "error.backendBody": "Se requiere el backend V2. No simulamos ni inventamos contenido.",
  "error.generic": "Algo salió mal. Referencia: {traceId}",
  "error.api_key_not_found": "Esa clave ya no existe. Puede que ya se haya revocado.",
  "error.api_key_name_reserved": "Ese nombre está reservado. Elige otro.",
  "error.project_not_found": "No se encontró ese proyecto en esta cuenta.",
  "error.file_exists":
    "{displayName} ya está en Archivos, así que no se guardó nada. Usa otro nombre o vuelve a guardar y elige reemplazarlo.",
  "error.authentication_required": "Tu sesión terminó. Inicia sesión de nuevo.",
  "error.run_not_ready": "Esta ejecución aún se está iniciando. Inténtalo de nuevo en un momento.",
  "error.run_not_resumable":
    "Esta conversación se cerró: terminó hace un tiempo o una ejecución más nueva la reemplazó. Inicia una nueva ejecución para continuar.",
  "error.rate_limited":
    "Demasiadas solicitudes en un minuto. Espera un momento e inténtalo de nuevo.",
  "error.run_budget_too_high":
    "Ese presupuesto supera el máximo por ejecución. Elige un tope menor.",
  "error.overlay_invalid":
    "El overlay de Foundry de este proyecto no es YAML válido, así que la ejecución no puede empezar.",
  "error.run_budget_required":
    "Una ejecución siempre tiene presupuesto. Elige un tope en lugar de quitarlo.",
  "error.run_command_not_allowed":
    "El agente se pausó para pedir tu intervención justo cuando se envió esto. Responde la solicitud pendiente e inténtalo de nuevo.",
  "error.command_in_progress":
    "El agente todavía está recibiendo una actualización anterior. Espera unos segundos e inténtalo de nuevo.",
  "error.revision_conflict": "Este proyecto cambió en otra ventana. Recarga antes de guardar.",
  "error.credit_cap_reached": "Esta cuenta necesita más créditos para ejecutar un agente.",
  "error.daily_run_cap_reached": "Ya no quedan ejecuciones por hoy; inténtalo mañana.",
  "error.model_not_allowed": "El modelo {model} no está disponible en este plan.",
  "error.tool_not_allowed": "La herramienta {tool} no está permitida para este perfil.",
  "error.session_tool_update_failed":
    "Esta sesión no pudo aplicar los cambios de herramientas, así que tu mensaje no se envió. Inténtalo de nuevo; los trabajos nuevos ya usan los cambios guardados.",
  "error.mcp_not_allowed": "Los conectores personalizados no están permitidos para este perfil.",
  "error.subscription_required": "Esta función requiere una suscripción activa.",
  "error.seePlans": "Ver planes →",
  "error.goal_required": "Primero dale una meta a tu agente: esa es la misión con la que trabaja.",
  "error.preferred_profile_unavailable":
    "Este proyecto está configurado para ejecutarse en {profileKey}, que ahora mismo no está disponible{code, select, profile_model_mismatch { — el modelo del agente cambió desde que lo elegiste} required_capability_missing { — una herramienta que necesita no está disponible en ese runtime} model_not_served { — ese modelo no se ejecuta en ese runtime} model_not_allowed { — ese modelo necesita un plan mayor} provider_not_allowed { — ese runtime necesita un plan mayor} reservations_paused { — ese runtime está en una pausa breve} provider_not_installed { — ese runtime no está configurado aquí} approval_mode_unsupported { — la forma en que pide permiso antes de usar una herramienta no está disponible en ese runtime} tool_not_allowed { — una herramienta que usa está desactivada para este perfil} mcp_not_allowed { — sus herramientas MCP necesitan un plan mayor} mcp_server_not_in_library { — usa un servidor MCP que no está en la biblioteca verificada} skills_unsupported { — sus habilidades aún no están disponibles en ese runtime} other {}}. Elige otro modelo en el panel de objetivo.",
  "error.profile_unavailable":
    "Ese perfil no está disponible ahora mismo{code, select, required_capability_missing { — una herramienta que este agente necesita no está disponible en ese runtime} model_not_served { — ese modelo no se ejecuta en ese runtime} model_not_allowed { — ese modelo necesita un plan mayor} provider_not_allowed { — ese runtime necesita un plan mayor} reservations_paused { — ese runtime está en una pausa breve} provider_not_installed { — ese runtime no está configurado aquí} approval_mode_unsupported { — la forma en que pide permiso antes de usar una herramienta no está disponible en ese runtime} tool_not_allowed { — una herramienta que usa está desactivada para este perfil} mcp_not_allowed { — sus herramientas MCP necesitan un plan mayor} mcp_server_not_in_library { — usa un servidor MCP que no está en la biblioteca verificada} skills_unsupported { — sus habilidades aún no están disponibles en ese runtime} profile_model_mismatch { — el modelo del agente cambió desde que lo elegiste} other {}}.",
  "error.profile_model_mismatch":
    "Ese perfil ejecuta {model}, no el modelo actual de este agente — cambia primero el modelo o elige un perfil para él.",
  "error.profile_key_invalid": "Ese perfil no es válido.",
  "error.runtime_provider_not_allowed":
    "Ningún runtime de este plan puede ejecutar agentes ahora mismo.",
  "error.no_runtime_provider_available":
    "No hay ningún runtime disponible para ejecutar agentes ahora mismo. Inténtalo de nuevo en un rato.",
  "error.model_unsupported_by_runtime":
    "El modelo de este agente no se ejecuta en el runtime elegido. Elige otro modelo en el panel de objetivo.",
  "error.tool_unsupported_by_runtime":
    "Una herramienta que usa este agente no está disponible en el runtime elegido. Elige otro modelo en el panel de objetivo o desactiva esa herramienta en Herramientas.",
  "error.tool_hitl_unsupported_by_runtime":
    "Pedir permiso antes de usar una herramienta web no está disponible en ese runtime. Pon la herramienta en Auto o elige otro modelo en el panel de objetivo.",
  "error.mcp_unsupported_by_runtime":
    "Las herramientas MCP de este agente no están disponibles en el runtime elegido. Elige otro modelo en el panel de objetivo.",
  "error.mcp_server_not_in_library":
    "Este agente usa un servidor MCP que no está en la biblioteca verificada. Quítalo en Herramientas para ejecutarlo.",
  "error.mcp_server_invalid":
    "{problem, select, no_toolset {El servidor MCP {server} no tiene un mcp_toolset, así que no se puede guardar. Añade uno; para apagar el servidor, conserva su toolset con default_config.enabled: false.} unknown_server {Un mcp_toolset nombra un servidor que no está en mcp_servers. Añade el servidor o quita el toolset.} duplicate {El servidor MCP {server} aparece más de una vez o tiene más de un mcp_toolset. Deja uno de cada.} url {El servidor MCP {server} necesita una dirección https válida con nombre de host: sin localhost, dirección IP ni puerto propio.} credentials {El servidor MCP {server} lleva un usuario o una contraseña en su dirección. Quítalos; una clave puede ir en la consulta (query) de la dirección.} shape {Los servidores MCP no tienen la forma correcta: cada uno necesita type: url, un nombre (hasta 64 letras, dígitos, - o _) y una url, y un agente puede tener como máximo 20.} other {Los servidores MCP de este agente no están bien configurados. Revisa mcp_servers y sus entradas mcp_toolset.}}",
  "error.mcp_server_unreachable":
    "{server} no responde ahora mismo, así que no se ejecutó nada. Inténtalo más tarde o quítalo en Herramientas.",
  "error.run_refused":
    "Este agente no puede ejecutarse tal como está configurado. Revisa sus herramientas y su modelo, y vuelve a intentarlo.",
  "error.provider_rejected":
    "El proveedor del modelo rechazó esta ejecución antes de empezar, así que no se ejecutó nada. Inténtalo más tarde; si sigue pasando, hay que revisar la configuración del proveedor del sitio.",
  "error.skills_unsupported_by_runtime":
    "Las habilidades de este agente aún no están disponibles en el runtime elegido. Elige otro modelo en el panel de objetivo.",
  "error.runtime_provider_not_installed":
    "Ese runtime no está configurado aquí. Elige otro modelo en el panel de objetivo.",
  "error.provider_not_allowed": "Ese runtime necesita un plan mayor.",
  "profile.myProfile": "Mi Perfil",
  "profile.openTemplates": "Ver plantillas →",
  "profile.subscription": "Suscripción",
  "profile.currentPlan": "Estás en el plan {plan}.",
  "profile.managePlan": "Gestionar plan",
  "apiKeys.title": "Claves de API",
  "apiKeys.intro":
    "Una clave permite que un script, una herramienta de línea de comandos u otro servicio llame a la API para tu cuenta en este sitio. Una clave de lectura puede consultar plantillas, proyectos y ejecuciones; una de escritura también puede guardar proyectos e iniciar ejecuciones.",
  "apiKeys.lastUsedNote": "El último uso se registra como mucho cada cinco minutos.",
  "apiKeys.empty": "Aún no tienes claves de API. Crea una abajo.",
  "apiKeys.caption": "Tus claves de API",
  "apiKeys.col.name": "Nombre",
  "apiKeys.col.prefix": "Empieza por",
  "apiKeys.col.access": "Acceso",
  "apiKeys.col.project": "Proyecto",
  "apiKeys.col.created": "Creada",
  "apiKeys.col.lastUsed": "Último uso",
  "apiKeys.col.expires": "Caduca",
  "apiKeys.col.actions": "Acciones",
  "apiKeys.access.read": "Lectura",
  "apiKeys.access.write": "Escritura",
  "apiKeys.allProjects": "Todos los proyectos",
  "apiKeys.unknownProject": "Proyecto {id}",
  "apiKeys.never": "Nunca",
  "apiKeys.expired": "Caducó el {date}",
  "apiKeys.revoke": "Revocar",
  "apiKeys.revokeLabel": "Revocar {name}",
  "apiKeys.revoking": "Revocando…",
  "apiKeys.revokeConfirm":
    "¿Revocar «{name}»? Todo lo que la use dejará de funcionar en su próxima solicitud. No se puede deshacer.",
  "apiKeys.create.title": "Crear una clave",
  "apiKeys.field.name": "Nombre",
  "apiKeys.field.namePlaceholder": "p. ej. Mi CLI",
  "apiKeys.field.access": "Acceso",
  "apiKeys.field.accessRead": "Lectura: consultar plantillas, proyectos y ejecuciones",
  "apiKeys.field.accessWrite": "Escritura: también guardar proyectos e iniciar ejecuciones",
  "apiKeys.field.project": "Proyecto",
  "apiKeys.field.expiry": "Caduca a los (días)",
  "apiKeys.field.expiryHint": "De 1 a 365. Déjalo vacío para una clave que no caduca.",
  "apiKeys.create.submit": "Crear clave",
  "apiKeys.create.lockedHint":
    "Guarda el secreto de la clave nueva y elige Listo antes de crear otra clave.",
  "apiKeys.projects.loading": "Cargando tus proyectos…",
  "apiKeys.projects.failed":
    "No se pudieron cargar tus proyectos, así que por ahora solo se puede crear una clave para todos los proyectos.",
  "apiKeys.projects.retry": "Reintentar",
  "apiKeys.projects.none": "Aún no tienes proyectos, así que la clave cubrirá todos los proyectos.",
  "apiKeys.secret.title": "Tu nueva clave",
  "apiKeys.secret.warning": "Cópiala ahora y guárdala en un lugar seguro. No se volverá a mostrar.",
  "apiKeys.secret.label": "Secreto de {name}",
  "apiKeys.secret.copy": "Copiar",
  "apiKeys.secret.copied": "Copiada",
  "apiKeys.secret.copyFailed": "No se pudo copiar. Selecciona la clave y cópiala tú.",
  "apiKeys.secret.done": "Ya la guardé",
  "comingNext.title": "El constructor llega en la próxima sección",
  "comingNext.body":
    "Los proyectos y las ejecuciones aún no forman parte de esta versión. Tu cuenta, las plantillas y tu plan están listos; construir y ejecutar agentes viene después.",
  "comingNext.keptIdea": "Tu idea se conserva:",
  "comingNext.templates": "Mientras tanto, explora las plantillas",
  "comingNext.history.title": "El historial de ejecuciones llega con los proyectos",
  "comingNext.history.body":
    "Las ejecuciones aún no forman parte de esta versión, así que no hay historial que mostrar. Cuando los proyectos y las ejecuciones lleguen en la próxima sección, cada ejecución que inicies aparecerá aquí.",
  "comingNext.marketplace.title": "El mercado llega en una sección posterior",
  "comingNext.marketplace.body":
    "Las plantillas de la comunidad y los enlaces de plantillas compartidas aún no forman parte de esta versión. Las plantillas oficiales ya están listas para explorar.",
  "comingNext.admin.title": "La hoja de costes llega en la Sección 2",
  "comingNext.admin.body":
    "Llegará cuando las ejecuciones registren su coste. El panel de administración ya está disponible en /admin.",
  "builder.blocks": "Bloques",
  "builder.yaml": "YAML del agente",
  "builder.workspace": "Espacio de trabajo",
  "builder.console": "Consola de ejecución",
  "builder.runAlreadyStarted": "Esta ejecución ya empezó.",
  "builder.openStartedRun": "Abrir la ejecución",
  "builder.projectSavedHint":
    "Abre la Biblioteca de Plantillas — tu trabajo queda guardado en este proyecto.",
  "builder.resizePanes": "Ajustar el tamaño de los paneles",
  "builder.run": "Ejecutar agente",
  "builder.running": "Ejecutando…",
  "builder.code": "Código",
  "builder.ready": "listo",
  "builder.jobRunning": "TAREA EN CURSO",
  "builder.stopping": "DETENIENDO…",
  "builder.preparingOutputs": "PREPARANDO RESULTADOS",
  "builder.needsYou": "TE NECESITA",
  "builder.answerNeeded": "RESPONDE",
  "builder.tabNeedsYou": "🔔 Te necesita — {project}",
  "builder.tabAnswer": "⭐ Responde al agente — {project}",
  "builder.newJob": "Nueva tarea",
  "canvas.whenRun": "cuando se pulsa Ejecutar",
  "canvas.setGoal": "define el objetivo",
  "canvas.config": "ajustes",
  "canvas.help": "ayúdame",
  "canvas.helpTitle": "convierte una idea general en una misión clara + rúbrica",
  "canvas.files": "Archivos:",
  "canvas.pill.uploads": "Subidas · {count}",
  "canvas.pill.memory": "Memoria · {count}",
  "canvas.repeatUntil": "repite hasta",
  "canvas.answerReady": "la respuesta está lista",
  "canvas.or": "o",
  "canvas.outOfTries": "sin intentos (máx {tries})",
  "canvas.think": "piensa en el siguiente paso",
  "canvas.toolbelt":
    "CAJA DE HERRAMIENTAS — TOCA PARA AÑADIR O QUITAR · EL AGENTE ELIGE EN CADA VUELTA",
  "canvas.addTool": "+ añadir herramienta",
  "canvas.team.title": "EQUIPO — EL AGENTE REPARTE EL TRABAJO ENTRE ESTOS MIEMBROS",
  "canvas.team.add": "+ añadir un equipo",
  "canvas.team.addMember": "+ añadir miembro",
  "canvas.team.remove": "Quitar a {member} del equipo",
  "canvas.team.removeTeam": "quitar el equipo",
  "canvas.team.advisor": "asesor",
  "canvas.team.advisorModel": "Modelo del asesor",
  "canvas.team.subagents": "subagentes",
  "canvas.team.workflows": "flujos",
  "canvas.team.inline": "puede definir los suyos",
  "canvas.team.listHasMembers": "Quita sus miembros antes de desactivar esta lista",
  "canvas.team.coordinatorNote":
    "Este equipo es un coordinador: edita su plantilla en la vista Código.",
  "canvas.team.readOnlyNote":
    "Este equipo está escrito en una forma que los bloques no editan: usa la vista Código.",
  "canvas.team.pickerTitle": "Añade un miembro al equipo",
  "canvas.team.pickerBlurb":
    "Agentes individuales publicados en este sitio. El miembro se une en su última versión publicada.",
  "canvas.team.pickerSearch": "Buscar por nombre",
  "canvas.team.pickerEmpty": "Ningún agente individual coincide.",
  "canvas.team.pickerMember": "ya es miembro",
  "canvas.lookBack": "mira lo que regresó",
  "canvas.goAround": "vuelve a empezar",
  "canvas.show": "muestra",
  "canvas.finalAnswer": "la respuesta final",
  "canvas.footerHint":
    "El agente repite este bucle una y otra vez hasta terminar el objetivo. Toca Código para ver el código real →",
  "canvas.gradersBadge": "{graders} evaluadores · {tries} intentos",
  "cfg.done": "listo",
  "cfg.goalHeader": "CONFIGURACIÓN DEL AGENTE — SINCRONIZADA CON YAML",
  "cfg.goalLabel": "OBJETIVO — QUÉ DEBE HACER EL AGENTE",
  "cfg.name": "NOMBRE",
  "cfg.description": "DESCRIPCIÓN",
  "cfg.model": "MODELO",
  "canvas.applySuggestion": "Aplicar la sugerencia",
  "cfg.systemPrompt": "INSTRUCCIÓN DEL SISTEMA",
  "cfg.toolbeltHeader": "CONFIGURACIÓN DE HERRAMIENTAS",
  "cfg.ask": "Pregunta",
  "cfg.auto": "Automático",
  "cfg.effect.allow": "permitido",
  "cfg.effect.ask": "te pregunta",
  "cfg.effect.provider_decides": "el agente decide",
  "cfg.support.none": "No disponible para este modelo aquí",
  "cfg.model.held": "El runtime de este modelo está en pausa.",
  "cfg.model.without": "Funciona sin {tools}",
  "cfg.mcpServers": "SERVIDORES MCP",
  "cfg.addServer": "+ servidor",
  "cfg.gradersHeader": "EVALUADORES — CÓMO PUNTUAMOS EL RESULTADO",
  "cfg.tries": "INTENTOS",
  "cfg.graderCatalog": "BIBLIOTECA DE EVALUADORES — MARCA LOS QUE IMPORTAN",
  "cfg.rubricHint":
    "Se envía como define_outcome: un evaluador aparte califica cada línea de la rúbrica y el agente reintenta hasta lograrlo o agotar los intentos.",
  "cfg.rubricLabel": "Así se ve terminado: tus propias líneas, una calificable por línea",
  "cfg.rubricPlaceholder":
    "fact-file.md existe con 5 criaturas abisales reales, cada una con un dato curioso",
  "cfg.composedRubric": "Rúbrica compuesta — se envía con define_outcome",
  "cfg.composedRubricFromFile":
    "La rúbrica viene del archivo seleccionado: las líneas de arriba no se envían.",
  "cfg.rubricWarnWrite":
    "⚠ Esta rúbrica espera un archivo o entregable, pero la herramienta de escritura está apagada. Actívala o elige un agente más adecuado.",
  "cfg.rubricWarnSearch":
    "⚠ Esta rúbrica espera investigación web, pero la herramienta de búsqueda está apagada. Actívala o elige un agente más adecuado.",
  "cfg.rubricSource": "FUENTE DE LA RÚBRICA",
  "cfg.rubricSourceInline": "texto en línea (la rúbrica de arriba)",
  "cfg.graderEmits": "emite →",
  "cfg.graderInfo": "detalles",
  "grader.detail.produced-result":
    "La comprobación más básica: ¿el agente realmente creó la cosa? Falla si la ejecución termina sin archivo, con un archivo vacío o con uno que da error al abrir.",
  "grader.detail.regex-present":
    "Coincidencia de patrón sin distinguir mayúsculas sobre la salida final: la forma más barata de exigir una sección, un título o una frase.",
  "grader.detail.must-mention":
    "La respuesta debe citar los términos indicados (separa varios con comas). Ser correcto en números pero no citar su base sigue siendo un fallo.",
  "grader.detail.numeric-tolerance":
    "Comprobación con verdad de referencia: recalcula el valor esperado a partir de los datos de origen y exige que el número más cercano de la respuesta caiga dentro del margen de tolerancia.",
  "grader.detail.ranked-mention":
    "Para misiones de 'ordena esto': el elemento clave debe aparecer en las primeras N filas de la lista o tabla ordenada.",
  "grader.detail.turn-budget":
    "Evaluador de eficiencia: respuesta correcta Y dentro del presupuesto. Correcto pero fuera de presupuesto cuenta como lento, así que la lentitud se ve sin reprobar la corrección.",
  "grader.detail.wall-budget": "Un tope de tiempo real para toda la ejecución, en segundos.",
  "grader.detail.text-judge.mfa":
    "Un juez LLM puntúa la redacción: claridad, corrección y adecuación al lector.",
  "grader.detail.coherence-judge":
    "Un juez LLM: cada título es una promesa y el cuerpo debe cumplirla.",
  "cfg.mcpModalTitle": "Añade un servidor de herramientas",
  "cfg.mcpModalBlurb":
    "Elige un servidor que tu agente pueda usar. Son gratis y no necesitan inicio de sesión.",
  "cfg.mcpLoading": "Cargando servidores…",
  "cfg.mcpEmpty": "No hay servidores disponibles ahora mismo.",
  "cfg.tryIt": "Pruébalo",
  "cfg.add": "Añadir",
  "cfg.added": "Añadido",
  "cfg.testing": "probando…",
  "cfg.testOk": "accesible ✓",
  "cfg.testFail": "no se pudo conectar",
  "mcpLib.deepwiki.name": "DeepWiki (docs de código abierto)",
  "mcpLib.deepwiki.blurb":
    "Haz preguntas sobre cualquier proyecto público de GitHub. Un servidor real, sin inicio de sesión.",
  "mcpLib.mslearn.name": "Microsoft Learn (docs de Microsoft)",
  "mcpLib.mslearn.blurb":
    "Busca en la documentación oficial de Microsoft y Azure. No necesita inicio de sesión.",
  "mcpLib.huggingface.name": "Hugging Face (modelos de IA)",
  "mcpLib.huggingface.blurb":
    "Busca modelos de IA, conjuntos de datos y artículos de investigación en Hugging Face. No necesita inicio de sesión.",
  "mcpLib.cloudflare-docs.name": "Cloudflare (documentación)",
  "mcpLib.cloudflare-docs.blurb":
    "Busca en la documentación de productos de Cloudflare. No necesita inicio de sesión.",
  "mcpLib.aws-knowledge.name": "AWS Knowledge (docs de AWS)",
  "mcpLib.aws-knowledge.blurb":
    "Busca en la documentación y guías oficiales de AWS. No necesita inicio de sesión.",
  "mcpLib.context7.name": "Context7 (docs de bibliotecas)",
  "mcpLib.context7.blurb":
    "Consulta documentación actualizada de bibliotecas de código populares. No necesita inicio de sesión (con límites de uso).",
  "mcpLib.gitmcp.name": "GitMCP (cualquier repo de GitHub)",
  "mcpLib.gitmcp.blurb":
    "Lee la documentación y busca en el código de cualquier proyecto público de GitHub. No necesita inicio de sesión.",
  "mcpLib.claude-docs.name": "Claude (documentación de Anthropic)",
  "mcpLib.claude-docs.blurb":
    "Busca en la documentación de Claude de Anthropic — modelos, API y guías. No necesita inicio de sesión.",
  "mcpLib.claude-code-docs.name": "Claude Code (documentación)",
  "mcpLib.claude-code-docs.blurb":
    "Busca en la documentación de Claude Code. No necesita inicio de sesión.",
  "mcpLib.ip-attribution.name": "Atribución de IP",
  "mcpLib.ip-attribution.blurb":
    "Consulta y atribuye direcciones IP — ASN, RDAP, reconocimiento e informes. No necesita inicio de sesión.",
  "mcpLib.comingSoon.mfa": "Próximamente.",
  "builder.stop": "Detener",
  "builder.runs.stopTitle": "Detener termina el turno del agente, no sus flujos.",
  "builder.saved": "Guardado",
  "builder.unsaved": "Cambios sin guardar",
  "builder.viewOnlyLive":
    "Esta ejecución está en marcha. La configuración es de solo lectura hasta que termine.",
  "builder.preflight.label": "Antes de ejecutar",
  "builder.preflight.checking": "Comprobando la ejecución…",
  "builder.preflight.failed": "No se pudo comprobar la ejecución.",
  "builder.preflight.retry": "Comprobar de nuevo",
  "builder.preflight.ready": "Lista para ejecutar",
  "builder.preflight.warnings": "Lista, con {count, plural, one {# aviso} other {# avisos}}",
  "builder.preflight.blocked":
    "{count, plural, one {# cosa bloquea} other {# cosas bloquean}} esta ejecución",
  "builder.preflight.details": "Detalles",
  "builder.preflight.hideDetails": "Ocultar detalles",
  "builder.preflight.cap": "Tope {amount} (máx. {max})",
  "builder.preflight.capLine":
    "Tope de gasto: {amount} por defecto; una ejecución puede llegar a {max}.",
  "builder.preflight.blockersTitle": "Qué bloquea esta ejecución",
  "builder.preflight.checksTitle": "Comprobaciones",
  "builder.preflight.needsTitle": "Lo que necesita la ejecución",
  "builder.preflight.severity.fail": "Fallo",
  "builder.preflight.severity.warn": "Aviso",
  "builder.preflight.severity.info": "Nota",
  "builder.preflight.needs.none": "Nada aparte del modelo.",
  "builder.preflight.needs.web": "Búsqueda o lectura web",
  "builder.preflight.needs.runsCode": "Ejecuta código en un entorno aislado",
  "builder.preflight.needs.connectors": "Conectores: {names}",
  "builder.preflight.needs.skills": "Habilidades: {names}",
  "builder.preflight.needs.mcpHosts": "Hosts MCP: {hosts}",
  "builder.preflight.blocker.agent_yaml_invalid": "No se puede leer la configuración del agente.",
  "builder.preflight.blocker.mcp_server_invalid": "La configuración de un conector no es válida.",
  "builder.preflight.blocker.overlay_invalid":
    "Los ajustes del motor (overlay) no son YAML válido.",
  "builder.preflight.blocker.engine_not_installed":
    "El motor de este modelo no está disponible en este sitio.",
  "builder.preflight.blocker.roster_member_not_found":
    "No se encuentra un miembro del equipo ({id}).",
  "builder.preflight.blocker.runner_unsupported":
    "El ejecutor elegido no puede servir a este agente.",
  "builder.preflight.blocker.mission_required": "Añade una meta antes de ejecutar.",
  "builder.preflight.blocker.memory_scope_unknown":
    "No existe un ámbito de memoria al que se une esta ejecución.",
  "builder.preflight.blocker.run_budget_too_high": "El tope supera el máximo por ejecución.",
  "builder.preflight.blocker.run_refused":
    "El motor rechazaría este agente: mira las comprobaciones.",
  "builder.preflight.blocker.other": "Bloqueado: {code}",
  "builder.preflight.edits.checking": "Comprobando tus cambios…",
  "builder.preflight.edits.failed": "No se pudieron comprobar tus cambios.",
  "builder.preflight.edits.refused": "Estos cambios no se guardarán: mira los detalles.",
  "builder.preflight.edits.blocked": "Tus cambios están bloqueados en {providers}.",
  "builder.preflight.edits.degraded": "Tus cambios tienen avisos en {providers}.",
  "builder.preflight.edits.ok": "Tus cambios están en orden.",
  "builder.preflight.gateTitle": "Guardar sería rechazado",
  "builder.preflight.runner.anthropic": "agentes gestionados",
  "builder.preflight.runner.service": "servicio sandbox",
  "builder.preflight.runner.loop": "bucle del servidor",
  "builder.preflight.word.ok": "correcto",
  "builder.preflight.word.degraded": "degradado",
  "builder.preflight.word.blocked": "bloqueado",
  "builder.preflight.word.unchecked": "sin comprobar",
  "builder.preflight.unchecked": "Sin comprobar aquí: {pairs}",
  "builder.preflight.block.identity": "Nombre",
  "builder.preflight.block.instructions": "Instrucciones",
  "builder.preflight.block.goal": "Meta",
  "builder.preflight.block.model": "Modelo",
  "builder.preflight.block.tools": "Herramientas",
  "builder.preflight.block.mcp": "Conectores",
  "builder.preflight.block.skills": "Habilidades",
  "builder.preflight.block.custom_tools": "Herramientas propias",
  "builder.preflight.block.outcome": "Terminado significa",
  "builder.preflight.block.team": "Equipo",
  "builder.preflight.block.runtime": "Ajustes del motor",
  "builder.preflight.block.run": "La ejecución",
  "canvas.mark.save": "No se guardará",
  "builder.mission": "Fija la meta",
  "builder.goalSeed": "{mission} — puedes usar {tools}",
  "builder.outcome": "Terminado significa",
  "builder.editorMode": "Modo de edición",
  "builder.yamlIntro":
    "Este YAML y los bloques describen el mismo agent.yaml. El servidor valida ambos.",
  "builder.yamlLoad": "Generar YAML",
  "builder.yamlApply": "Aplicar YAML",
  "builder.yamlNotMap": "agent.yaml debe ser un mapa de claves",
  "builder.codeTabs": "Documento",
  "builder.codeTabAgent": "agent.yaml",
  "builder.codeTabOverlay": "overlay",
  "builder.overlay": "Overlay del proyecto",
  "builder.overlayIntro":
    "El overlay fija cómo se ejecuta este proyecto: su runner, los ámbitos de memoria y los asientos de modelo. Se guarda por la misma puerta que el agente.",
  "builder.overlayEmpty":
    "Este proyecto aún no tiene overlay. Escribe uno aquí y Aplica; Guardar lo crea.",
  "builder.overlayNotMap": "el overlay debe ser un mapa de claves",
  "builder.opRefused":
    "Un cambio no se puede guardar así ({reason}). Deshazlo o corrígelo en Código.",
  "builder.saveAndRun": "Guardar y ejecutar",
  "builder.finalizing": "Finalizando resultados…",
  "builder.finalizationFailed": "Algunos resultados no se pudieron finalizar.",
  "builder.viewOutputs": "Ver resultados ({count})",
  "files.title": "Archivos",
  "files.subtitle": "Todo lo que este agente usa y crea, en un solo lugar.",
  "files.sources": "Fuentes de archivos",
  "files.search": "Buscar nombres y rutas",
  "files.refresh": "Actualizar",
  "files.upload": "Subir archivo",
  "files.uploadArtifact": "Subir artefacto",
  "files.newArtifact": "Nuevo artefacto",
  "files.newMemory": "Nueva nota",
  "files.close": "Cerrar Archivos",
  "files.source.all": "Todo",
  "files.source.uploads": "Cargas",
  "files.source.artifacts": "Artefactos del usuario",
  "files.source.skills": "Habilidades",
  "files.source.logs": "Registros de sesión",
  "files.source.memory": "Memoria",
  "files.source.yaml": "Configuración YAML",
  "files.runFilter": "Mostrando artefactos creados por esta ejecución.",
  "files.clearRunFilter": "Mostrar todos los artefactos",
  "files.empty": "Aún no hay archivos que coincidan con esta vista.",
  "files.emptyFinalizing":
    "Los resultados aún se están finalizando — aparecerán aquí en un momento.",
  "files.resize": "Ajusta el tamaño de la lista y la vista previa (arrastra o usa las flechas)",
  "files.select": "Elige un archivo para ver sus detalles y contenido.",
  "files.loadMore": "Cargar más",
  "files.download": "Descargar",
  "files.edit": "Editar",
  "files.editElsewhere": "Abrir editor",
  "files.delete": "Eliminar",
  "files.deleteConfirm": "¿Eliminar este elemento de Archivos?",
  "files.replaceConfirm": "{name} ya está en Archivos. ¿Quieres reemplazarlo?",
  "files.previewUnavailable": "La vista previa no está disponible para este elemento.",
  "files.previewTruncated":
    "Esta es una vista previa limitada. Descárgalo para ver el archivo completo.",
  "files.binaryPreview":
    "Este archivo binario no se puede previsualizar de forma segura. Descárgalo para verlo.",
  "files.preview.markdown": "Vista previa del documento con formato",
  "files.preview.code": "Vista previa del código resaltado",
  "files.origin.agent": "Creado por agente",
  "files.origin.user": "Subido",
  "files.editor.artifact": "Artefacto del usuario",
  "files.editor.memory": "Nota de memoria",
  "files.artifactName": "Nombre del artefacto",
  "files.memoryPath": "Ruta de memoria",
  "files.content": "Contenido",
  "files.restore": "Restaurar",
  "files.showArchived": "Mostrar memoria archivada",
  "files.archived": "Archivado",
  "canvas.pill.artifacts": "{count} artefactos",
  "templates.title.mfa": "Biblioteca de plantillas",
  "templates.viewAs": "Ver como",
  "templates.viewAs.all": "Todas las plantillas",
  "tpl.subtitle":
    "Empieza desde un agente listo. Cada plantilla es YAML real que puedes abrir y ajustar.",
  "tpl.allCategories": "Todas",
  "tpl.searchLabel": "Buscar plantillas",
  "tpl.searchPlaceholder": "Busca por nombre, descripción o palabra clave…",
  "tpl.filter.kind": "Equipo o individual",
  "tpl.filter.kind.all": "Todas",
  "tpl.filter.kind.team": "Equipos",
  "tpl.filter.kind.single": "Agentes individuales",
  "tpl.filter.inTeam": "Pertenencia a equipos",
  "tpl.filter.inTeam.any": "Cualquiera",
  "tpl.filter.inTeam.yes": "En un equipo",
  "tpl.filter.inTeam.no": "Independientes",
  "tpl.filter.category": "Categoría",
  "tpl.filter.industry": "Sector",
  "tpl.filter.collections": "Colecciones",
  "tpl.filter.capabilities": "Capacidades",
  "tpl.filter.clear": "Borrar filtros",
  "tpl.filter.showing": "Mostrando {shown} de {total}",
  "tpl.filter.from": "Origen",
  "tpl.filter.from.all": "Ambos sitios",
  "tpl.filter.toggle": "Filtros{count, plural, =0 {} other { (#)}}",
  "tpl.sort": "Ordenar",
  "tpl.sort.recommended": "Recomendado",
  "tpl.sort.title": "Título A–Z",
  "tpl.sort.newest": "Más recientes",
  "tpl.noResults.title": "Ninguna plantilla coincide con estos filtros",
  "tpl.noResults.body": "Prueba con menos filtros u otra búsqueda.",
  "tpl.card.homeSite": "De {site}",
  "tpl.card.moreChips": "+{count}",
  "tpl.card.team": "Equipo · {count, plural, one {# miembro} other {# miembros}}",
  "tpl.card.members": "Miembros: {names}{more, plural, =0 {} other { +#}}",
  "tpl.card.alsoInTeam": "También en el equipo: {name}",
  "tpl.card.inTeams": "En {count} equipos",
  "tpl.card.original": "Original",
  "tpl.loading":
    "La estantería de plantillas está cargando; si tarda mucho, el servidor puede estar desconectado.",
  "tpl.upsellTitle": "Haz más con Pro",
  "tpl.upsellBody": "Pro desbloquea modelos más capaces y más ejecuciones para cada plantilla.",
  "tpl.goPro": "Hazte Pro",
  "tpl.freePlanBadge": "PLAN GRATIS",
  "tpl.agentYaml": "YAML del agente",
  "tpl.useTemplate": "Usar esta plantilla →",
  "tpl.seePlans": "Ver planes →",
  // Detalle de plantilla (organización de plantillas, PR-5); un solo bloque, ver en.
  "tpl.detail.kind.team": "Equipo · {count, plural, one {# miembro} other {# miembros}}",
  "tpl.detail.kind.single": "Agente individual",
  "tpl.detail.facets": "Categoría, sectores y palabras clave",
  "tpl.detail.members": "Miembros",
  "tpl.detail.usedInTeams": "Se usa en estos equipos",
  "profile.choose": "¿Qué modelo debería usar?",
  "profile.runsOn": "se ejecuta en {provider}",
  "profile.limitation": "Se ejecuta sin {capability}",
  "profile.reason.provider_not_installed": "Este modelo aún no está disponible aquí.",
  "provider.anthropic": "Anthropic",
  "provider.openrouter": "OpenRouter",
  "provider.foundry": "Microsoft Foundry",
  "cfg.runsOn": "SE EJECUTA EN",
  "templates.empty": "No hay plantillas para este perfil e idioma.",
  "billing.title.mfa": "Tu plan",
  "billing.title.lya": "Plan del espacio de trabajo",
  "billing.plan": "Plan actual",
  "billing.renewsOn": "Se renueva el {date}",
  "billing.paidThrough": "Pagado hasta el {date}",
  "billing.grace.banner": "Hay un problema con el pago: tu plan sigue activo hasta el {date}.",
  "billing.grace.cta": "Arreglar el pago",
  "billing.scheduled.banner.downgrade": "Tu plan cambia a {name} el {date}.",
  "billing.scheduled.banner.cadence": "Tu período de facturación cambia el {date}.",
  "billing.scheduled.banner.cancel": "Tu plan de pago termina el {date}.",
  "billing.scheduled.cancelCta": "Mantener mi plan actual",
  "billing.portal.link": "Gestionar facturación y facturas",
  "billing.processing.title": "Terminando tu compra…",
  "billing.processing.body": "Estamos confirmando tu pago: suele tardar unos segundos.",
  "billing.processing.still": "Sigue en proceso: actualiza para comprobarlo de nuevo.",
  "billing.checkout.cancelled": "El pago se canceló: no se hizo ningún cambio.",
  "billing.selection.applied": "Tu compra se completó. El plan de abajo está al día.",
  "billing.selection.failed": "Esa compra no se completó, así que tu plan no cambió.",
  "billing.selection.expired": "Ese pago caducó antes de terminarse, así que tu plan no cambió.",
  "billing.selection.canceled": "Ese cambio se canceló, así que tu plan no cambió.",
  "billing.selection.superseded": "Una elección de plan más reciente reemplazó a esa.",
  "billing.selection.unknown":
    "No encontramos esa compra en esta cuenta. El plan de abajo es el actual.",
  "billing.offerLink.confirm": "¿Cambiar tu plan a {name} por {price}?",
  "attach.addFiles": "Adjuntar archivos",
  "attach.chips": "Archivos que estás adjuntando",
  "attach.status.uploading": "Subiendo…",
  "attach.status.preparing": "Agregando para el agente…",
  "attach.status.ready": "Listo",
  "attach.status.saved": "Guardado para tu próxima tarea",
  "attach.status.checking": "Comprobando si el archivo se agregó…",
  "attach.status.removing": "Quitando…",
  "attach.status.failed": "No se pudo agregar este archivo",
  "attach.retry": "Reintentar",
  "attach.remove": "Quitar",
  "attach.retryFile": "Reintentar agregar {name}",
  "attach.removeFile": "Quitar {name}",
  "attach.blockedExplain":
    "Enviar espera a que todos los archivos adjuntos estén listos para el agente — un momento más.",
  // Consola de ejecución en equipo (B8).
  "builder.team": "Equipo",
  "run.status.queued": "En cola",
  "run.status.preparing": "Preparando",
  "run.status.starting": "Iniciando",
  "run.status.running": "Ejecutando",
  "run.status.waiting_for_input": "Te necesita",
  "run.status.requires_action": "Te necesita",
  "run.status.satisfied": "Completo",
  "run.status.needs_revision": "Necesita revisión",
  "run.status.failed": "Falló",
  "run.status.interrupted": "Detenido",
  "run.status.max_iterations_reached": "Límite de turnos",
  "run.status.unknown": "Terminado",
  "history.title": "Historial de ejecuciones",
  "history.subtitle": "Todas las ejecuciones de tus proyectos, primero las más recientes.",
  "history.empty": "Aún no hay ejecuciones: ejecuta un agente desde el Constructor.",
  "history.loadMore": "Cargar más",
  "history.colWhen": "Cuándo",
  "history.colProject": "Proyecto",
  "history.colStatus": "Estado",
  "history.colWho": "Quién",
  "history.colModel": "Modelo",
  "nav.marketplace": "Mercado",
  "error.draft_revision_conflict":
    "Alguien más guardó este borrador primero. Cargamos su última revisión: guarda de nuevo para aplicar tus cambios.",
  "error.template_key_exists": "Ya existe una plantilla con esta clave en la biblioteca.",
  "error.template_archived": "Esta plantilla está archivada. Desarchívala para publicar de nuevo.",
  "error.library_key_exists": "Ya existe una biblioteca con esta clave.",
  "error.import_has_errors": "Esta importación tiene errores de validación y no se puede aplicar.",
  "error.import_hash_mismatch": "El paquete subido cambió; vuelve a prepararlo antes de aplicarlo.",
  "builder.upgrade.available": "Actualización de plantilla disponible: v{from} → v{to}.",
  "builder.upgrade.members":
    "{count, plural, one {Miembro del equipo actualizado} other {Miembros del equipo actualizados}}: {names}.",
  "builder.upgrade.memberVersions": "v{from} → v{to}",
  "builder.upgrade.applyMembers": "Actualizar los miembros del equipo",
  "builder.upgrade.review": "Revisar actualización",
  "builder.upgrade.auto": "se actualiza automáticamente",
  "builder.upgrade.conflict": "también lo cambiaste — elige una opción:",
  "builder.upgrade.keepMine": "Mantener lo mío",
  "builder.upgrade.takeTemplate": "Usar la plantilla",
  "builder.upgrade.apply": "Aplicar v{version}",
  "builder.upgrade.chooseFirst": "Resuelve cada sección en conflicto antes de aplicar.",
  "builder.upgrade.saveFirst": "Guarda tus cambios antes de actualizar.",
  "builder.upgrade.starterFiles": "archivos de inicio",
  "builder.upgrade.starterFilesAdded":
    "añade {count, plural, one {un archivo} other {# archivos}} a tus subidas: {names} (un archivo que ya tienes conserva tu copia)",
  "error.upgrade_choices_required": "Elige una opción para cada sección en conflicto primero.",
  // ---- shell público (portado del splash/pricing/catálogo de V1) ----
  "publicNav.templates": "Plantillas",
  "publicNav.pricing": "Planes y facturación",
  "publicNav.signIn": "Iniciar sesión",
  "publicNav.startFree": "Empieza gratis",
  "splash.badge.mfa": "Pensado para quienes crean su primer agente",
  "splash.badge.lya": "Para fundadores y equipos",
  "splash.hero1.mfa": "Crea tu primer",
  "splash.hero2.mfa": "agente de IA.",
  "splash.hero1.lya": "Lanza tus propios",
  "splash.hero2.lya": "agentes de IA.",
  "splash.sub.mfa":
    "Encaja bloques, dale una misión y mira cómo un agente de IA real se pone a trabajar: piensa, usa herramientas y termina la tarea.",
  "splash.sub.lya":
    "Diseña un agente, asígnale un trabajo y mira cómo un agente de IA real se pone en marcha: razona, usa tus herramientas y entrega resultados.",
  "splash.ctaTemplates": "Ver plantillas",
  "splash.ctaPlans": "Ver los planes",
  "splash.trust.lya": "Sin tarjeta de crédito • Empieza gratis, cancela cuando quieras",
  "splash.blocks.when": "cuando pulses Ejecutar",
  "splash.blocks.goal": "fija la meta en",
  "splash.blocks.goalValue": "explorar Marte 🚀",
  "splash.blocks.repeat": "repite hasta que",
  "splash.blocks.repeatValue": "la respuesta esté lista",
  "splash.blocks.tool": "usa una herramienta",
  "splash.blocks.show": "muestra la respuesta",
  "splash.feature1.title.mfa": "Encaja los bloques",
  "splash.feature1.body.mfa":
    "Construye el cerebro del agente de forma visual. Cambia a Código cuando quieras para ver el original.",
  "splash.feature2.title.mfa": "Míralo trabajar de verdad",
  "splash.feature2.body.mfa":
    "Un agente de IA real ejecuta tu misión en vivo: piensa en voz alta, usa herramientas y te consulta.",
  "splash.feature3.title.mfa": "Sube de nivel con plantillas",
  "splash.feature3.body.mfa": "Empieza con un agente listo, ajusta el YAML y hazlo tuyo.",
  "splash.feature1.title.lya": "Diséñalo a tu manera",
  "splash.feature1.body.lya":
    "Compón el agente de forma visual o en YAML: la especificación siempre es la real.",
  "splash.feature2.title.lya": "Míralo trabajar de verdad",
  "splash.feature2.body.lya":
    "Un agente de IA real ejecuta el trabajo en vivo: razona, usa tus herramientas e informa.",
  "splash.feature3.title.lya": "Empieza con plantillas",
  "splash.feature3.body.lya": "Parte de un agente probado, adáptalo a tu flujo y ponlo en marcha.",
  // ---- splash solo de MFA (spec del owner 2026-07-26; el campo del héroe ES el paso 1) ----
  "mfaSplash.nav.how": "Cómo funciona",
  "mfaSplash.nav.pricing": "Precios",
  "mfaSplash.nav.logIn": "Entrar",
  "mfaSplash.badge": "TU PRIMER AGENTE · EMPIEZA GRATIS",
  "mfaSplash.hero.title": "Tu primer agente de IA está a una frase de distancia.",
  "mfaSplash.hero.sub":
    "Di qué debe hacer. Míralo armarse con bloques de verdad. Luego dale órdenes. Inicia sesión gratis — la construcción empieza justo después.",
  "mfaSplash.prompt.label": "¿QUÉ DEBE HACER TU AGENTE?",
  "mfaSplash.prompt.build": "Constrúyelo →",
  "mfaSplash.prompt.note":
    "Plan Spark gratis al iniciar sesión — sin tarjeta y con límites honestos.",
  "mfaSplash.chip.1": "Hazme preguntas sobre el espacio",
  "mfaSplash.chip.2": "Ordena mis descargas en carpetas",
  "mfaSplash.chip.3": "Crea trivia para la noche de juegos",
  "mfaSplash.chip.4": "Inventa una máquina de cuentos para dormir",
  "mfaSplash.how.title": "Tres pasos. Cero manuales.",
  "mfaSplash.how.1.t": "Dilo",
  "mfaSplash.how.1.d": "Una frase, cualquier idea. Sin respuestas incorrectas y sin manuales.",
  "mfaSplash.how.2.t": "Míralo construirse",
  "mfaSplash.how.2.d":
    "Tu agente se arma con bloques de verdad — una meta, un cerebro, habilidades. Toca Código para ver qué hay dentro.",
  "mfaSplash.how.3.t": "Dale órdenes",
  "mfaSplash.how.3.d":
    "Pulsa Ejecutar. Tu agente piensa en voz alta, hace el trabajo y te muestra cada paso.",
  "mfaSplash.tpl.title": "¿Aún sin ideas? Elige un agente listo para usar.",
  "mfaSplash.tpl.sub": "Cada plantilla es código real que puedes abrir, ejecutar y ajustar.",
  "mfaSplash.tpl.kids": "Para empezar",
  "mfaSplash.tpl.teens": "Avanzado",
  "mfaSplash.tplName.aiPet": "Mascota de IA",
  "mfaSplash.tplName.showdown": "Duelo de superpoderes animales",
  "mfaSplash.tplName.poem": "Escritor de poemas en archivos",
  "mfaSplash.tplName.web": "Explicador de páginas web",
  "mfaSplash.tplName.aiBoss": "Jefe de IA",
  "mfaSplash.tplName.inspector": "Inspector de seguridad de apps",
  "mfaSplash.tplName.data": "Analista de datos",
  "mfaSplash.tplName.sheets": "Constructor de hojas de cálculo",
  "mfaSplash.tpl.aiPet": "Un compañero de IA juguetón con misiones de aprendizaje y creatividad.",
  "mfaSplash.tpl.showdown": "Enfrenta habilidades reales de animales y corona a un campeón.",
  "mfaSplash.tpl.poem":
    "Convierte cualquier cosa — tu día, tu perro — en poemas que guarda como archivos.",
  "mfaSplash.tpl.web": "Lee cualquier página y la explica con palabras que de verdad se entienden.",
  "mfaSplash.tpl.aiBoss":
    "Dirige trabajo de IA como un líder de proyecto — planifica, delega, verifica, entrega.",
  "mfaSplash.tpl.inspector": "Aprende por qué las apps piden permisos y juzga si una es segura.",
  "mfaSplash.tpl.data":
    "Procesa hojas de cálculo y encuentra la historia escondida en los números.",
  "mfaSplash.tpl.sheets":
    "Describe un registro o un presupuesto — recibe una hoja de cálculo que funciona.",
  "mfaSplash.tag.create": "crear",
  "mfaSplash.tag.research": "investigar",
  "mfaSplash.tag.security": "seguridad",
  "mfaSplash.tag.code": "código",
  "mfaSplash.pricing.title": "Empieza gratis. Mejora cuando se te quede pequeño.",
  "mfaSplash.pricing.sub":
    "Spark es gratis para siempre. Los planes de pago añaden cerebros más potentes y más ejecuciones.",
  "mfaSplash.pricing.free": "gratis para siempre",
  "mfaSplash.pricing.perMonth": "al mes",
  "mfaSplash.pricing.start": "EMPIEZA AQUÍ",
  "mfaSplash.pricing.popular": "EL MÁS POPULAR",
  "mfaSplash.pricing.cta": "Ver precios completos →",
  "mfaSplash.pricing.annualAvailable":
    "La facturación anual está disponible en los planes de pago.",
  "mfaSplash.footer.navLabel": "Pie de página",
  "mfaSplash.footer.tagline": "Hecho para primeros agentes. Listo para trabajo real.",
  "mfaSplash.footer.privacy": "Privacidad",
  "mfaSplash.footer.terms": "Términos",
  "mfaSplash.footer.copyright": "© 2026 New Machine, Inc.",
  "notFound.title": "Página no encontrada",
  "notFound.body":
    "No hay nada en esta dirección. El enlace puede ser antiguo o la página puede haberse movido.",
  "notFound.home": "Ir a la página de inicio",
  "notFound.templates": "Ir a las plantillas",
  "error.chunkTitle": "Esta parte de la aplicación no se cargó",
  "error.chunkBody": "Tu conexión puede haberse cortado durante la descarga. Inténtalo de nuevo.",
  "pricing.title": "Planes y facturación",
  "pricing.cta.start": "Empieza gratis",
  "pricing.cta.current": "Plan actual",
  "pricing.cta.free": "Cambiar a Gratis",
  "pricing.cta.downgrade": "Bajar de plan",
  "pricing.cta.get": "Consigue {name}",
  "pricing.cta.switchAnnual": "Cambiar a anual",
  "pricing.cta.switchMonthly": "Cambiar a mensual",
  "pricing.cta.unavailable": "Muy pronto",
  "pricing.confirmDowngrade": "¿Bajar al plan {name}?",
  "error.unknown_offer": "Esa oferta no está disponible aquí.",
  "error.plan_not_found": "Ese plan no está disponible para el cambio.",
  "error.admin_required": "Esta acción requiere una cuenta de administrador.",
  "error.plan_switch_live_subscription":
    "Esta cuenta tiene una suscripción activa: cancélala en el portal de facturación antes de cambiar.",
  "error.plan_switch_pending_change":
    "Ya hay un cambio de plan en curso: deja que termine o cancélalo primero.",
  "pricing.badge.testing": "Probando este plan",
  "error.pending_change_exists": "Ya hay un cambio de plan programado: cancélalo primero.",
  "error.billing_unavailable":
    "La facturación no está disponible ahora mismo: inténtalo de nuevo en un rato.",
  "error.change_not_found": "Ese cambio programado ya no existe.",
  "error.billing_customer_not_found":
    "No encontramos tus datos de facturación: contacta con soporte.",
  "planGrid.perMonth": "/mes",
  "catalog.signInToUse": "Inicia sesión para usarla",
  "catalog.back": "Todas las plantillas",
  "account.profile": "Perfil",
  "wizard.cta.title": "¿No sabes por dónde empezar?",
  "wizard.cta.body": "Responde unas preguntas y crearemos tu primer agente juntos.",
  "wizard.cta.button": "Empezar el asistente guiado →",
  "wizard.title": "Crea tu primer agente",
  "wizard.step": "Paso {current} / {total}",
  "wizard.next": "Siguiente →",
  "wizard.create": "Crear mi agente",
  "wizard.retryDraft": "Terminar la configuración",
  "wizard.idea.title": "¿Qué debería hacer tu agente?",
  "wizard.idea.placeholder": "Quiero un agente que…",
  "wizard.details.title": "¿Qué haría una buena primera versión?",
  "wizard.details.placeholder": "Una buena primera versión…",
  "wizard.shape.title": "¿Para quién es y qué debería crear?",
  "wizard.audience.me": "Mí",
  "wizard.audience.team": "Un equipo",
  "wizard.audience.customers": "Clientes",
  "wizard.output.brief": "Resumen breve",
  "wizard.output.brief.desc": "Una respuesta fácil de leer.",
  "wizard.output.checklist": "Lista de tareas",
  "wizard.output.checklist.desc": "Pasos o tareas a seguir.",
  "wizard.output.file": "Archivo guardado",
  "wizard.output.file.desc": "Un archivo que escribe el agente.",
  "wizard.output.message": "Mensaje borrador",
  "wizard.output.message.desc": "Listo para pegar o enviar luego.",
  "wizard.tools.title": "¿Qué puede usar?",
  "wizard.tools.web": "Búsqueda web",
  "wizard.tools.web.desc": "Usa fuentes actuales.",
  "wizard.tools.files": "Archivos",
  "wizard.tools.files.desc": "Leer archivos subidos.",
  "wizard.tools.write": "Escribir resultados",
  "wizard.tools.write.desc": "Crear archivos y resultados.",
  "wizard.brief.title": "El resumen de tu agente",
  "wizard.brief.agent": "Agente",
  "wizard.brief.model": "Modelo",
  "wizard.model.default": "Elige por mí",
  "wizard.brief.tools": "Herramientas",
  "wizard.brief.output": "Resultado",
  "wizard.brief.outcome": "Así se ve terminado",
  "wizard.brief.next": "Buenos próximos pasos",
  "wizard.next.run": "Ejecútalo una vez, ajusta el objetivo y guarda el mejor resultado.",
  "wizard.compose.role": "Eres un agente cuidadoso y amable creado con un cuestionario guiado.",
  "wizard.compose.job": "Trabajo: {idea}",
  "wizard.compose.context": "Más contexto: {details}",
  "wizard.compose.audience": "Público: {audience}.",
  "wizard.compose.output": "Resultado: {output}.",
  "wizard.compose.askFirst":
    "Cuando falte información, haz una pregunta clara en lugar de adivinar.",
  "wizard.outcome.summary": "Así se ve terminado: {idea}",
  "wizard.outcome.goal": "Cumple el objetivo del usuario: {idea}",
  "wizard.outcome.useful": "Produce un {output} útil para {audience}",
  "wizard.outcome.explain": "Explica lo que hizo y señala cualquier información faltante",
  // --- LYA corporate rebrand (2026-07): professional counterparts (see en).
  "auth.kidsNote.lya": "Los datos de tu espacio de trabajo son privados: nunca los vendemos.",
  "auth.emailLabel.lya": "Correo de trabajo",
  "mcpLib.comingSoon.lya": "Conexión disponible próximamente.",
  "grader.detail.text-judge.lya":
    "Un juez LLM evalúa la escritura: claridad, corrección y adecuación a la audiencia.",
  "templates.title.lya": "Biblioteca de plantillas",
  // --- 2026-07-25 plans handoff (drafts pending native review). Catalog copy
  // llega ya localizado del servidor desde el corte de comercio 2026-07-28.
  "pricing.subhead.lya.plans":
    "El uso se comparte en tu espacio de trabajo: cada ejecución usa los modelos Claude de Anthropic.",
  "pricing.subhead.mfa.plans":
    "Todos los planes usan los modelos Claude de Anthropic: los planes más grandes desbloquean modelos más inteligentes y más ejecuciones.",
  "pricing.billing.label": "Período de facturación",
  "pricing.billing.monthly": "Mensual",
  "pricing.billing.annual": "Anual",
  "pricing.billedMonthly": "facturación mensual",
  "pricing.perYear": "/año",
  "pricing.free": "Gratis",
  "pricing.freeNote": "sin tarjeta de crédito",
  "pricing.models.label": "Modelos Claude",
  "pricing.cta.upgrade": "Mejorar",
  "pricing.district.title": "¿Todo el equipo o la empresa?",
  "pricing.district.body":
    "Puestos a medida, SSO, listas y facturación: preparamos un presupuesto contigo.",
  "pricing.district.cta": "Habla con nosotros",
  "pricing.footnote.lya":
    "Todos los planes usan los modelos Claude de Anthropic · Precios en USD · Cancela cuando quieras",
  "pricing.footnote.mfa":
    "Todos los planes usan los modelos Claude de Anthropic · Precios en USD · Cancela cuando quieras",
  "nav.admin": "Panel de administración (interno)",
  // --- Herramientas de desarrollo (solo dev).
  "devtools.menu": "Herramientas de desarrollo",
  "devtools.dashboard.title": "Herramientas de desarrollo",
  "devtools.dashboard.subtitle":
    "Vistas solo de desarrollo de este sitio: sus procedimientos de la API, tus ejecuciones recientes y tus proyectos.",
  "devtools.tabs": "Secciones de las herramientas de desarrollo",
  "devtools.tab.overview": "Resumen",
  "devtools.tab.rpc": "RPC",
  "devtools.tab.runs": "Ejecuciones",
  "devtools.signInPrompt":
    "Las ejecuciones y los proyectos pertenecen a una cuenta: inicia sesión para ver los tuyos. La pestaña RPC funciona sin sesión.",
  "devtools.overview.environment": "Esta sesión",
  "devtools.overview.site": "sitio: {site}",
  "devtools.overview.role": "rol: {role}",
  "devtools.overview.build": "versión: {build}",
  "devtools.picker.runs": "Ejecuciones recientes",
  "devtools.picker.noRuns": "Esta cuenta aún no tiene ejecuciones.",
  "devtools.picker.colRun": "Ejecución",
  "devtools.picker.colProject": "Proyecto",
  "devtools.picker.colStatus": "Estado",
  "devtools.picker.colModel": "Modelo",
  "devtools.picker.colRunner": "Ejecutor",
  "devtools.picker.colStarted": "Inicio",
  "devtools.picker.colSandboxTime": "Tiempo de sandbox (estimación)",
  "devtools.picker.colSandboxTimeHint":
    "Ejecuciones por la ruta sandbox: el tiempo activo del sandbox, sus ventanas y una estimación de Azure a precio de lista. No se cobra.",
  "devtools.picker.projects": "Proyectos",
  "devtools.picker.noProjects": "Esta cuenta aún no tiene proyectos.",
  "devtools.picker.projectMeta": "revisión {revision} · actualizado {updated}",
  "devtools.runs.back": "Volver a la lista",
  "devtools.notFound.run": "Esta cuenta no puede ver ninguna ejecución con este id.",
  "devtools.notFound.project": "Esta cuenta no puede ver ningún proyecto con este id.",
  "devtools.run.title": "Ejecución {id}",
  "devtools.run.status": "Estado",
  "devtools.run.stopReason": "Motivo de parada",
  "devtools.run.agent": "Agente",
  "devtools.run.model": "Modelo",
  "devtools.run.profile": "Perfil",
  "devtools.run.runner": "Ejecutor",
  "devtools.run.runnerReasons": "(al servicio le falta: {reasons})",
  "devtools.run.cost": "Costo",
  "devtools.run.costUnavailable": "no disponible",
  "devtools.run.usageState": "(uso {state}, liquidado: {settled})",
  "devtools.run.runtimeCharged": "Tiempo de ejecución (cobrado)",
  "devtools.run.sandboxTime": "Tiempo de sandbox (estimación de Azure, no se cobra)",
  "devtools.sandboxTime.value":
    "{awake} · {windows, plural, one {# ventana} other {# ventanas}} · ~{usd}",
  "devtools.sandboxTime.detail":
    "({estimated, plural, =0 {todos los cierres observados} one {# cierre estimado} other {# cierres estimados}}{open, select, true {, una ventana abierta} other {}}; nivel {tier})",
  "devtools.sandboxTime.tooltip":
    "Tiempo de sandbox: una estimación de Azure a precio de lista sobre las ventanas activas del sandbox, incluidos los minutos inactivos antes de la suspensión de 300 s. No se cobra. Tiempo de ejecución (cobrado): {runtime}.",
  "devtools.sandboxTime.last24h":
    "Sesiones de sandbox en las últimas 24 h: {sessions} · activo {awake} · {windows, plural, one {# ventana} other {# ventanas}} · ~{usd} (estimación de Azure, no se cobra)",
  "devtools.run.finalization": "Finalización",
  "devtools.run.providerStatus": "Sesión del proveedor",
  "devtools.run.started": "Inicio",
  "devtools.run.project": "Proyecto",
  "devtools.run.openProject": "Abrir proyecto",
  "devtools.run.capabilities": "Lo que permite la ejecución (solo lectura)",
  "devtools.run.capabilityOn": "{name}: sí",
  "devtools.run.capabilityOff": "{name}: no",
  "devtools.connection": "Conexión: {state}",
  "devtools.connection.connecting": "conectando",
  "devtools.connection.live": "en vivo",
  "devtools.connection.polling": "en vivo (sondeo)",
  "devtools.connection.reconnecting": "reconectando",
  "devtools.connection.retryingHistory": "reintentando el historial",
  "devtools.connection.ended": "terminada",
  "devtools.connection.error": "error de conexión",
  "devtools.events.title": "Eventos",
  "devtools.events.type": "Tipo",
  "devtools.events.source": "Origen",
  "devtools.events.allTypes": "Todos los tipos",
  "devtools.events.allSources": "Todos los orígenes",
  "devtools.events.count": "Mostrando {shown} de {total}",
  "devtools.events.showMore": "Mostrar más",
  "devtools.events.empty": "Aún no hay eventos.",
  "devtools.events.noMatch": "Ningún evento coincide con estos filtros.",
  "devtools.events.truncated":
    "Más de {max} eventos: aquí solo se guardan los {max} más recientes.",
  "devtools.outputs.title": "Resultados",
  "devtools.outputs.empty": "Esta ejecución no tiene entregables.",
  "devtools.outputs.notLive":
    "La sesión de esta ejecución ya no existe, así que no se pueden listar sus entregables.",
  "devtools.outputs.preview": "Vista previa",
  "devtools.outputs.hide": "Ocultar vista previa",
  "devtools.outputs.binary": "Archivo binario: descárgalo para abrirlo.",
  "devtools.outputs.download": "Descargar",
  "devtools.project.openBuilder": "Abrir en el Constructor",
  "devtools.project.runs": "Ejecuciones",
  "devtools.project.noRuns": "Este proyecto aún no tiene ejecuciones.",
  "devtools.preflight.title": "Comprobación previa",
  "devtools.preflight.note":
    "La comprobación previa solo revisa condiciones locales. La disponibilidad del proveedor, la aceptación de Claude Managed Agents y el descubrimiento de MCP en vivo siguen siendo desconocidos hasta que empieza la ejecución.",
  "devtools.preflight.mission": "Misión (opcional)",
  "devtools.preflight.budget": "Presupuesto en dólares (opcional)",
  "devtools.preflight.budgetInvalid": "Indica un importe entre $0.01 y $10,000.",
  "devtools.preflight.check": "Comprobar",
  "devtools.preflight.checking": "Comprobando…",
  "devtools.preflight.result": "Resultado de la comprobación previa",
  "devtools.preflight.ready": "Lista",
  "devtools.preflight.blocked": "Bloqueada",
  "devtools.preflight.facts": "revisión {revision} · motor {engine} · comprobada {checkedAt}",
  "devtools.preflight.engineMissing": "ninguno elegido",
  "devtools.preflight.engineNotInstalled": "{engine} (no instalado)",
  "devtools.preflight.mission.input": "Misión: de la entrada",
  "devtools.preflight.mission.goal": "Misión: el objetivo del proyecto",
  "devtools.preflight.mission.missing": "Misión: falta",
  "devtools.preflight.budgetLine": "Presupuesto: {amount}",
  "devtools.preflight.budgetDefault": "Presupuesto: {amount} (el predeterminado)",
  "devtools.preflight.blockers": "Bloqueos",
  "devtools.preflight.enforced": "Obligatorias",
  "devtools.preflight.enforcedHint": "Un hallazgo obligatorio que falla impide el inicio.",
  "devtools.preflight.advisory": "Orientativas",
  "devtools.preflight.advisoryHint":
    "Claude Managed Agents no ejecuta estas comprobaciones al iniciar una ejecución, así que allí nunca la bloquean. Muestran lo que diría el verificador.",
  "devtools.preflight.noFindings": "Ninguno.",
  "devtools.preflight.agents": "Agentes",
  "devtools.preflight.profiles": "Perfiles de modelo",
  "devtools.preflight.probedOn": "probado el {date}",
  "devtools.preflight.stale": "desactualizado",
  "devtools.preflight.warnings": "Advertencias de compilación",
  "devtools.preflight.unchecked": "Sin comprobar",
  "devtools.inspect.title": "Inspeccionar",
  "devtools.inspect.run": "Inspeccionar ejecución {id}",
  "devtools.inspect.project": "Abrir proyecto {id}",
  "devtools.subtitle":
    "Cada procedimiento que declara el contrato, ejecutado con el cliente de la propia app: mismas cookies, mismas cabeceras, como tú.",
  "devtools.anonymousBanner":
    "No has iniciado sesión, así que las llamadas se ejecutan de forma anónima. Inicia sesión para probar los procedimientos que la necesitan.",
  "devtools.procedures": "Procedimientos",
  "devtools.badges": "Datos del procedimiento",
  "devtools.badge.public": "funciona sin sesión",
  "devtools.badge.session": "necesita sesión",
  "devtools.badge.idempotency": "Idempotency-Key desde requestId",
  "devtools.badge.sessionChanging": "cambia la sesión",
  "devtools.inputSchema": "Esquema de entrada",
  "devtools.outputSchema": "Esquema de salida",
  "devtools.input": "Entrada (JSON)",
  "devtools.noInput": "Este procedimiento no recibe entrada.",
  "devtools.parseError": "La entrada no es JSON válido: {message}",
  "devtools.idempotencyKey": "Cabecera Idempotency-Key: {value}",
  "devtools.idempotencyMissing": "(indica requestId en la entrada)",
  "devtools.newRequestId": "Nuevo requestId",
  "devtools.execute": "Ejecutar",
  "devtools.running": "Ejecutando…",
  "devtools.sessionChangingNote":
    "Cambia la cookie de sesión: usa el inicio y cierre de sesión de la app.",
  "devtools.success": "Correcto",
  "devtools.result": "Resultado",
  "devtools.errorResult": "Respuesta de error",
  "devtools.timing": "{ms} ms (cabeceras {headersMs} ms)",
  "devtools.networkError": "La solicitud nunca obtuvo respuesta: {message}",
  "devtools.raw.title": "HTTP sin procesar",
  "devtools.raw.request": "Solicitud",
  "devtools.raw.response": "Respuesta",
  "devtools.raw.redacted": "[oculto]",
  "devtools.raw.browserAdded": "(la añade el navegador)",
  "devtools.raw.cookieExpected":
    "{name}=… esperada (la añade el navegador; su valor HttpOnly nunca se puede leer aquí)",
  "devtools.raw.originNote":
    "Una escritura con cookie de sesión debe enviar el Origin de este mismo sitio, o el servidor la rechaza (la regla CSRF).",
  "devtools.raw.noBody": "(sin cuerpo)",
  "devtools.raw.noResponse": "Sin respuesta: la solicitud nunca obtuvo respuesta.",
  "devtools.raw.eventStream": "Flujo de eventos: solo cabeceras.",
  "devtools.raw.truncated": "Se muestran los primeros {kb} KB; el resto del cuerpo no se leyó.",
  "devtools.raw.copyCurl": "Copiar como curl",
  "devtools.raw.copyWarning":
    "Puede contener datos de la cuenta: no lo pegues en tickets ni en chats.",
  "devtools.raw.copied": "Copiado.",
  "devtools.raw.copyFallback": "No se puede copiar aquí; selecciona el comando de abajo.",
  "devtools.examples.load": "Cargar entrada…",
  "devtools.examples.examples": "Ejemplos",
  "devtools.examples.saved": "Guardadas",
  "devtools.examples.skeleton": "Esqueleto vacío",
  "devtools.examples.templateOption": "{name} (Plantilla de entrada — completa los ids)",
  "devtools.examples.saveAs": "Guardar como…",
  "devtools.examples.save": "Guardar",
  "devtools.examples.delete": "Eliminar «{name}»",
  "devtools.examples.notStored": "Las entradas de este procedimiento nunca se guardan.",
  "devtools.examples.storageHint":
    "Las entradas guardadas se almacenan con tu cuenta para este sitio (solo herramientas de desarrollo). No guardes nada secreto.",
  "devtools.examples.notSaved.signedOut":
    "Sin guardar: sin sesión, las entradas duran solo en esta pestaña. Inicia sesión para conservarlas.",
  "devtools.examples.notSaved.unavailable":
    "Sin guardar: el almacenamiento no está disponible ahora, así que las entradas duran solo en esta pestaña.",
  "devtools.examples.notSaved.refused":
    "Sin guardar: tus entradas guardadas superan los límites de la cuenta ({totalKb} KB en total), así que los últimos cambios duran solo en esta pestaña. Elimina algunas para guardarlos.",
  "devtools.examples.outcome.saved": "Guardada.",
  "devtools.examples.outcome.refused": "Las entradas de este procedimiento nunca se guardan.",
  "devtools.examples.outcome.badName": "Ponle un nombre de 1 a {length} caracteres.",
  "devtools.examples.outcome.tooLarge": "Demasiado grande para guardar (el límite es {kb} KB).",
  "devtools.examples.outcome.full":
    "Este procedimiento ya tiene {count} entradas guardadas. Elimina una primero.",
  "devtools.examples.outcome.noRoom":
    "Sin espacio: tus entradas guardadas tienen un límite de {totalKb} KB en total. Elimina algunas primero.",
  "devtools.examples.placeholderHint":
    "Esta entrada aún tiene un marcador entre ángulos: sustitúyelo por un id real de la llamada indicada antes de ejecutar.",
  "devtools.examples.mismatch": "No coincide con el esquema de entrada: {issues}",
  "devtools.developersLink":
    "Los mismos procedimientos y rutas, con el documento OpenAPI, para cualquiera: {link}.",
  "apiKeys.reference": "Qué puede llamar una clave, con el documento OpenAPI: {link}.",
  "developers.nav": "Desarrolladores",
  "developers.eyebrow": "Referencia de la API",
  "developers.title": "Desarrolladores",
  "developers.intro":
    "Todo lo que hace el sitio también puede hacerlo un script. La API bajo {prefix} sirve cada procedimiento y cada ruta de esta página a un script, una herramienta de línea de comandos u otro front-end, como JSON plano sobre HTTPS.",
  "developers.version": "Wire {wire}, versión {version}",
  "developers.versionLoading": "Leyendo la versión del wire…",
  "developers.versionOffline":
    "El documento servido no se pudo leer ahora; esta página describe la versión {version}, con la que se construyó.",
  "developers.document": "Documento OpenAPI",
  "developers.documentNote":
    "OpenAPI 3.1, generado a partir de los contratos: cada llamada de esta página con sus esquemas, el acceso que necesita una clave y el único cuerpo de error. Público, desde cualquier origen. Dáselo a un generador de clientes o a un asistente.",
  "developers.credentials.title": "Credenciales",
  "developers.credentials.body":
    "Una clave de cuenta, creada en tu página de perfil y mostrada una sola vez, va en una cabecera Authorization: Bearer o en X-Api-Key. Una clave de lectura puede ver plantillas, proyectos y ejecuciones; una de escritura también puede guardar proyectos e iniciar ejecuciones. Una clave es un secreto: guárdala en una variable de entorno en un servidor o un portátil, nunca en una página. Un front-end en un origen permitido usa en su lugar una sesión bearer, y las páginas del propio sitio usan su cookie.",
  "developers.credentials.link": "Gestiona tus claves de API",
  "developers.quickstart.title": "Primeros pasos",
  "developers.quickstart.curl": "Con curl",
  "developers.quickstart.curlNote":
    "Los marcadores entre ángulos los rellenas tú. La clave viene del entorno; esta página nunca muestra ninguna.",
  "developers.quickstart.cli": "Con la línea de comandos v5",
  "developers.quickstart.cliNote":
    "El cliente de referencia, construido desde el repositorio: lista el catálogo, inicia y sigue una ejecución, responde a sus preguntas y guarda lo que produjo.",
  "developers.procedures.title": "Procedimientos",
  "developers.procedures.body":
    "Cada procedimiento es POST {prefix}/{area}/{name}: la entrada como cuerpo JSON ({empty} o sin cuerpo cuando no toma ninguna) y la salida como respuesta JSON. Un rechazo responde con su estado HTTP y un único cuerpo de error: code, status, message, data y traceId.",
  "developers.procedures.none": "sin entrada",
  "developers.schema.input": "Esquema de entrada",
  "developers.schema.output": "Esquema de salida",
  "developers.access.read": "lectura",
  "developers.access.write": "escritura",
  "developers.access.public": "funciona sin credencial",
  "developers.access.noKeys": "sin claves",
  "developers.access.cookieOnly": "solo cookie del sitio",
  "developers.access.idempotencyRequired": "Idempotency-Key obligatoria",
  "developers.access.idempotencyOptional": "Idempotency-Key admitida",
  "developers.access.sessionChanging": "crea o borra la cookie de sesión",
  "developers.routes.title": "Rutas",
  "developers.routes.body":
    "Las rutas escritas a mano junto a los procedimientos: el flujo de eventos en vivo de una ejecución, los bytes de un entregable o de una subida, las subidas, la instantánea del catálogo y el propio documento. Cada una responde en su propia ruta y en su propio tipo de medio.",
  "developers.routes.method": "Método",
  "developers.routes.path": "Ruta",
  "developers.routes.summary": "Qué hace",
  "developers.routes.access": "Acceso",
  "developers.routes.media": "Responde",
  "developers.footnote":
    "Dentro de {prefix} el wire solo cambia por adición: nuevos procedimientos, entradas opcionales, campos de salida y miembros de enumeración. Un cliente ignora lo que no conoce. Cada respuesta lleva la cabecera {header} con la versión del wire; un cambio incompatible se publicaría junto a v5, nunca en su lugar.",
};

export const catalogs = { en, es } as const;

/**
 * Site-suffixed message id with fallback: `${base}.${suffix}` when the
 * catalog defines it, otherwise the base id. Lets dynamic id families
 * (`error.${code}`, `grader.detail.${id}`) fork per site only where a pair
 * exists, without duplicating every member of the family.
 */
export function suffixedMessageId(base: string, suffix: "mfa" | "lya"): string {
  const candidate = `${base}.${suffix}`;
  return candidate in en ? candidate : base;
}

/**
 * Copy suffix for the active site, read from the `data-site` attribute the
 * app stamps on <html> at boot. Exists for leaf components (error text,
 * config panels) whose unit tests render them without AppContextProvider —
 * the "mfa" default preserves their historical MFA voice there. Components
 * that already consume useAppContext() should derive the suffix from
 * `experience.id` instead.
 */
export function siteSuffix(): "mfa" | "lya" {
  return typeof document !== "undefined" &&
    document.documentElement.dataset.site === "launchyouragent"
    ? "lya"
    : "mfa";
}

/** The message map for the current locale. Copy ships compiled; there is no server overlay. */
export function resolveMessages(locale: keyof typeof catalogs): Record<string, string> {
  return catalogs[locale];
}
